
namespace TabAurous.ItemGridHelper {
    export function SetPurchaseItemGrid(Items: any[], date: Date, PartyId: number, ExchangeRate: number, RateListId: number, LaborListId: number, LaborMarkup: number, GenSKU: boolean, GenLineNo: boolean) {
        let ItemDetails = [];
        Q.reloadLookup(OMS.DepartmentMasterRow.lookupKey);


        Items.forEach(function (Item) {
            // #region variables
            let genSKU = GenSKU;
            let DeptId = 0;
            let CompanyId = Q.Authorization.userDefinition.CompanyId;
            let Rate = 0;
            let LaborRate = 0;
            let Pieces = 0;
            let Weight = 0;
            let Amount = 0;
            let Cost = 0;
            let Studded: number;
            let Purity = 0;
            let PurityDetails: OMS.AttributeMasterRow;
            let bomdetails = [];
            let labordetail = [];
            let LotNo = "";
            let AVGRate = 0;

            let VoucherDetails = Q.first(OMS.VoucherMasterRow.getLookup().items, x => x.VoucherTypeId == 13);
            switch (Item.ItemTypeId) {
                case 101:
                    DeptId = VoucherDetails.DefaultJewelleryDepartment;
                    break;
                case 104:
                    DeptId = VoucherDetails.DefaultMetalDepartment;
                    break;
                case 105:
                    DeptId = VoucherDetails.DefaultStoneDepartment;
                    break;
            }

            // #endregion

            // #region RM Rate
            try {
                switch (Item.ItemTypeId) {
                    case 104:
                        // TODO: Add Currency, Date, Rate Type
                        Item.Line_No = 0;
                        if (Item.TransId == null) {
                            Rate = RateHelper.GetMetalRate(Item.ProductTypeId, Item.KaratId, false, date) / ExchangeRate;


                            Stock.StockItemService.GetWeightedAVGRate(
                                {
                                    ItemTypeId: 104, ProductTypeId: Item.ProductTypeId
                                },
                                response => AVGRate = response.Rate,
                                {
                                    async: false
                                }
                            );
                            let abc = AVGRate;
                        }
                        else {
                            Rate = Item.UnitRate;
                            Weight = Item.Weight;
                            Pieces = Item.Pieces;
                        }
                        Studded = 0;
                        Item.Pieces = Item.Pieces >= 0 ? Item.Pieces : 0;

                        if (Item.Purity == 0) {
                            let KaratId = Item.KaratId;
                            let purity: OMS.AttributeMasterRow;
                            OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                purity = response.Entity
                            }, { async: false });
                            let std = purity.StdPurity;
                            Item.Purity = std;
                        }
                        break;
                    case 105:
                        if (Item.TransId == null) {
                            Rate = RateHelper.GetStonePurchaseRate(Item.AttributeId, RateListId, Item.ProductId, Item.CostMethodId) / ExchangeRate;
                        }
                        else {
                            Rate = Item.UnitRate;
                            Weight = Item.Weight;
                            Pieces = Item.Pieces;
                        }
                        Studded = 0;
                        LotNo = FormatHelper.GetFormats("Lot");
                        Item.Pieces = Item.Pieces >= 0 ? Item.Pieces : 0;
                        Item.Line_No = 0;
                        break;
                }
            }
            catch (undefined) {
                Q.notifyWarning("Rate not defined for " + Item.ProductCode);
            }

            // #endregion

            // #region FG
            if (Item.ItemTypeId == 101) {
                if (Item.Line_No == null && GenLineNo) {
                    Purchase.PurchaseMasterService.GetLineNo({}, response => Item.Line_No = response.Line_No, {
                        async: false
                    });
                }
                if (genSKU == true && !Item.IsDefaultSKU && Q.isEmptyOrNull(Item.SKU)) {
                    Item.SKU = FormatHelper.GetFormats("SKU");
                    Studded = 1;
                }
                else {
                    Item.SKU = "";
                    Studded = 0;
                }

                Pieces = 1;
                Weight = Item.Weight == 0 ? 1 : Item.Weight;
                if (Item.TransId == null || Item.VoucherTypeId != 53 && Item.VoucherTypeId != 54) {
                    Item.Pieces = 1;

                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                        ProductId: Item.ProductId,
                        AttributeId: Item.AttributeId,
                        RateListId: LaborListId,
                        Markup: LaborMarkup,
                        Pieces: Item.Pieces,
                        Weight: Item.Weight,
                        NetWeight: Item.NetWeight
                    }

                    let ItemLabor: Purchase.PurchaseLaborRow[] = RateHelper.GetPurchseLabour(LaborOpt)
                    if (ItemLabor.length > 0)
                        for (let i = 0; i < ItemLabor.length; i++) {
                            ItemLabor[i].LabourRate = ItemLabor[i].LabourRate / ExchangeRate;
                            ItemLabor[i].LabourAmount = ItemLabor[i].LabourAmount / ExchangeRate;
                            ItemLabor[i].CCLabourAmount = ItemLabor[i].LabourAmount;
                            LaborRate += ItemLabor[i].LabourAmount;
                            labordetail.push(ItemLabor[i]);
                        }
                }
                else {
                    labordetail = Item.LaborDetails;
                    for (let i = 0; i < labordetail.length; i++) {

                        LaborRate += labordetail[i].LabourAmount;
                    }
                }


                if (!Item.HasBom) {

                    Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                    if (Item.TransId == null)
                        Rate = RateHelper.GetMetalRate(Item.MetalId, Item.KaratId, false, date) / ExchangeRate;
                    else
                        Rate = Item.UnitRate;
                    if (Item.Purity == 0) {
                        let purity: OMS.AttributeMasterRow;
                        OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(Item.KaratId) }, response => {
                            purity = response.Entity
                        }, { async: false });
                        let min = purity.MinPurity;
                        let max = purity.MaxPurity;
                        let std = purity.StdPurity;
                        Purity = std;
                    } else
                        Purity = Item.Purity
                }


                // #region ProductBOM
                if (Item.HasBom) {
                    Item.BOMDetails.forEach(function (ItemBOM) {
                        if (ItemBOM.TransBomId == null)
                            ItemBOM.TransBomId = 0;
                        switch (ItemBOM.ItemTypeId) {
                            case 104:
                                let BOMRate = 0;
                                if (Item.TransId == null || Item.VoucherTypeId != 53 && Item.VoucherTypeId != 54)
                                    BOMRate = RateHelper.GetMetalRate(ItemBOM.ProductTypeId, ItemBOM.KaratId, false, date) / ExchangeRate;
                                else
                                    BOMRate = ItemBOM.BomRate;

                                let MetalBOMAmount = 0;
                                let MetalCCBOMAmount = 0;
                                let UseKaratRate = q.ToBool(GetConfigValue(1014));

                                if (UseKaratRate == true) {
                                    MetalBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) : (ItemBOM.Weight * BOMRate);
                                    MetalCCBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) * ExchangeRate : (ItemBOM.Weight * BOMRate) * ExchangeRate;
                                }
                                else {
                                    MetalBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) : (ItemBOM.Weight * ItemBOM.Purity * BOMRate);
                                    MetalCCBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) * ExchangeRate : (ItemBOM.Weight * ItemBOM.Purity * BOMRate) * ExchangeRate;

                                }
                                Rate += MetalBOMAmount;

                                let Metal: Purchase.PurchaseItemsBOMRow = {
                                    ProductId: ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: MetalBOMAmount,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: ItemBOM.CalcOn,
                                    Pieces: ItemBOM.Pieces == null ? 0 : ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    ItemType: ItemBOM.ItemType,
                                    ProductTypeId: ItemBOM.ProductTypeId,
                                    CategoryId: ItemBOM.CategoryId,
                                    SubCategoryId: ItemBOM.SubCategoryId,
                                    KaratId: ItemBOM.KaratId,
                                    MetalColorId: ItemBOM.MetalColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    Purity: ItemBOM.Purity,
                                    PureWeight: ItemBOM.PureWeight == null ? ItemBOM.Purity * ItemBOM.Weight : ItemBOM.PureWeight,
                                    RefTransBomId: ItemBOM.TransBomId,
                                    CCBomAmount: MetalBOMAmount * ExchangeRate,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    SettingId: 0,
                                    Parts: ItemBOM.Parts == null ? 1 : ItemBOM.Parts,
                                    StoneStatusId: 1,
                                    TextureId: ItemBOM.TextureId == null ? 0 : ItemBOM.TextureId,
                                    PointerWeight: ItemBOM.PointerWeight == null ? 0 : ItemBOM.PointerWeight,

                                }
                                bomdetails.push(Metal);
                                break;
                            case 105:
                                BOMRate = 0;
                                if (Item.TransId == null || Item.VoucherTypeId != 53 && Item.VoucherTypeId != 54)
                                    BOMRate = RateHelper.GetStonePurchaseRate(ItemBOM.BOMAttributeId, RateListId, ItemBOM.BOMProductId, ItemBOM.CostMethodId, ItemBOM.Weight) / ExchangeRate;
                                else
                                    BOMRate = ItemBOM.BomRate;
                                let StoneBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) : (ItemBOM.Weight * BOMRate);
                                let StoneCCBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) * ExchangeRate : (ItemBOM.Weight * BOMRate) * ExchangeRate;
                                Rate += StoneBOMAmount;
                                if (Item.TransId == null || Item.VoucherTypeId != 53 && Item.VoucherTypeId != 54) {
                                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                                        ProductId: ItemBOM.BOMProductId,
                                        AttributeId: ItemBOM.BOMAttributeId,
                                        RateListId: LaborListId,
                                        Markup: LaborMarkup,
                                        Pieces: ItemBOM.Pieces,
                                        Weight: ItemBOM.Weight,
                                        NetWeight: 0,
                                        SettingId: 0,
                                        IsCustomerItem: ItemBOM.IsCustomerItem
                                    }
                                    let ComponentLabor: Purchase.PurchaseLaborRow[] = RateHelper.GetPurchseLabour(LaborOpt);
                                    if (ItemBOM.SettingId !== null && ItemBOM.SettingId > 0) {
                                        LaborOpt.SettingId = ItemBOM.SettingId;
                                        let SettingLabor: Purchase.PurchaseLaborRow[] = RateHelper.GetPurchseLabour(LaborOpt);
                                        if (SettingLabor.length > 0)
                                            for (let setting of SettingLabor)
                                                ComponentLabor.push(setting);
                                    }

                                    if (ComponentLabor.length > 0) {
                                        for (let i = 0; i < ComponentLabor.length; i++) {
                                            ComponentLabor[i].LabourRate = ComponentLabor[i].LabourRate / ExchangeRate;
                                            ComponentLabor[i].LabourAmount = ComponentLabor[i].LabourAmount / ExchangeRate;
                                            ComponentLabor[i].CCLabourAmount = ComponentLabor[i].LabourAmount;
                                            LaborRate += ComponentLabor[i].LabourAmount;
                                            labordetail.push(ComponentLabor[i]);
                                        }
                                    }
                                }

                                let Stone: Purchase.PurchaseItemsBOMRow = {
                                    ProductId: ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: StoneBOMAmount,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: ItemBOM.CalcOn,
                                    Pieces: ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemType: ItemBOM.ItemType,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    StoneColorId: ItemBOM.StoneColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    CategoryId: ItemBOM.CategoryId,
                                    SubCategoryId: ItemBOM.SubCategoryId,
                                    ProductTypeId: ItemBOM.ProductTypeId,
                                    QualityId: ItemBOM.QualityId,
                                    SieveId: ItemBOM.SieveId,
                                    ShapeId: ItemBOM.ShapeId,
                                    StoneSizeId: ItemBOM.StoneSizeId,
                                    SettingId: ItemBOM.SettingId == null ? 0 : ItemBOM.SettingId,
                                    GroupSieveId: ItemBOM.GroupSieveId,
                                    StoneCuletId: ItemBOM.StoneCuletId,
                                    StoneCutId: ItemBOM.StoneCutId,
                                    StoneFluorescenceId: ItemBOM.StoneFluorescenceId,
                                    StoneGirdleId: ItemBOM.StoneGirdleId,
                                    StonePolishId: ItemBOM.StonePolishId,
                                    StoneSymmetryId: ItemBOM.StoneSymmetryId,
                                    StoneDepth: ItemBOM.StoneDepth,
                                    StoneTable: ItemBOM.StoneTable,
                                    RefTransBomId: ItemBOM.TransBomId,
                                    CCBomAmount: StoneBOMAmount * ExchangeRate,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    Purity: 0,
                                    PureWeight: 0,
                                    StoneStatusId: 1,
                                    TextureId: 0,
                                    Parts: ItemBOM.Parts == null ? 0 : ItemBOM.Parts
                                }
                                bomdetails.push(Stone)
                                break;
                        }
                    });
                }
                // #endregion
            }

            // #endregion

            // #region Amount Calculation
            if (Item.ItemTypeId == 101) {
                Cost = Rate + LaborRate;
                Amount = Item.HasBom == true ? (Rate + LaborRate) * Pieces : (Rate * Weight) * Purity || 0;
            }
            else if (Item.ItemTypeId == 104) {
                Item.Pieces = Item.Pieces != null ? Item.Pieces : 0;
                Cost = Rate + LaborRate;
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Pieces : (Rate * Weight) * Purity || 0;

            }
            else if (Item.ItemTypeId == 105) {
                Item.Pieces = Item.Pieces != null ? Item.Pieces : 0;
                Cost = Rate + LaborRate;
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Pieces : Rate * Weight || 0;
            }

            // #endregion

            let PurchaseItem: Purchase.PurchaseItemsRow = {
                ProductId: Item.ProductId,
                AttributeId: Item.AttributeId,
                Attribute: Item.Attribute,
                Line_No: Item.Line_No,
                PartyId: PartyId,
                SKU: Item.SKU,
                DepartmentId: 0,
                ProductCode: Item.ProductCode,
                ProductName: Item.ProductName,
                ItemTypeId: Item.ItemTypeId,
                HasBom: Item.HasBom,
                CategoryId: Item.CategoryId,
                CategoryName: Item.CategoryName,
                ProductTypeId: Item.ProductTypeId,
                ProductTypeName: Item.ProductTypeName,
                SubCategoryId: Item.SubCategoryId,
                SubCategoryName: Item.SubCategoryName,
                BrandId: Item.BrandId,
                SuperTypeId: Item.SuperTypeId,
                CollectionId: Item.CollectionId,
                ProductSizeId: Item.ProductSizeId,
                UnitRate: Rate,
                UnitLabour: LaborRate,
                UnitCost: Cost,
                Pieces: Item.Pieces,
                Weight: Item.Weight,
                OtherPieces: Item.OtherPieces == null ? 0 : Item.OtherPieces,
                OtherWeight: Item.OtherWeight == null ? 0 : Item.OtherWeight,
                StonePieces: Item.StonePieces == null ? 0 : Item.StonePieces,
                StoneWeight: Item.StoneWeight == null ? 0 : Item.StoneWeight,
                NetWeight: Item.NetWeight == null ? 0 : Item.NetWeight,
                NetAmount: Amount,
                GrossAmount: Amount,
                DiamondPieces: Item.DiamondPieces == null ? 0 : Item.DiamondPieces,
                DiamondWeight: Item.DiamondWeight == null ? 0 : Item.DiamondWeight,
                CalcOnId: Item.CalcOnId,
                BOMDetails: bomdetails,
                LaborDetails: labordetail,
                CompanyId: CompanyId,
                HSN: Item.HSN,
                TaxCode: Item.TaxCode,
                MetalId: Item.MetalId,
                KaratId: Item.KaratId,
                MetalColorId: Item.MetalColorId,
                QualityId: Item.QualityId,
                SieveId: Item.SieveId,
                ShapeId: Item.ShapeId,
                StoneColorId: Item.StoneColorId,
                StoneSizeId: Item.StoneSizeId,
                ImageName: Item.ImageName,
                Studded: Studded, // marking item as bulk
                StoneCutId: Item.StoneCutId,
                StonePolishId: Item.StonePolishId,
                StoneSymmetryId: Item.StoneSymmetryId,
                StoneFluorescenceId: Item.StoneFluorescenceId,
                StoneCuletId: Item.StoneCuletId,
                StoneGirdleId: Item.StoneGirdleId,
                StoneTable: Item.StoneTable,
                StoneDepth: Item.StoneDepth,
                Purity: Item.Purity,
                CalcUnitId: Item.CalcUnitId,
                PureWeight: Weight * Item.Purity,
                RefVoucherId: Item.VoucherTypeId == null ? 0 : Item.VoucherTypeId,
                RefTransId: Item.TransId == null ? 0 : Item.TransId,
                RefTransItemId: Item.TransItemId == null ? 0 : Item.TransItemId,
                StockAllocation: Item.TransId == null ? false : true,
                CCGrossAmount: Amount * ExchangeRate,
                CCNetAmount: Amount * ExchangeRate,
                LotNo: LotNo,
                BagNo: Item.BagNo,
                CertificateNo: Item.CertificateNo,
                Hallmark: Item.Hallmark,
                HUID: Item.HUID,
                StampId: Item.StampId,
                Parts: Item.Parts

            };

            ItemDetails.push(PurchaseItem);
        });

        return ItemDetails;
    }

    export function SetSalesItemGrid(Items: any[], date: Date, PartyId: number, ExchangeRate: number, RateListId: number, LaborListId: number, LaborMarkup: number) {
        let ItemDetails = [];

        let useCostRate = q.ToBool(GetConfigValue(1023));
        let CompanyId = Q.Authorization.userDefinition.CompanyId;
        Items.forEach(function (Item) {
            // #region variables
            let Rate = 0;
            let LaborRate = 0;
            let Pieces = 0;
            let Weight = 0;
            let BOMRate = 0;
            let Amount = 0;
            let Cost = 0;
            let Studded: number;
            let MetalAmount = 0;
            let Purity = 0;
            let PurityDetails: OMS.AttributeMasterRow;
            let bomdetails = [];
            let labordetail = [];
            let Location: string;
            // #endregion

            // #region RM Rate
            try {
                switch (Item.ItemTypeId) {
                    case 104:
                        // TODO: Add Currency, Date, Rate Type
                        if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && useCostRate == false) {
                            Rate = RateHelper.GetMetalRate(Item.ProductTypeId, Item.KaratId, false, date) / ExchangeRate;
                        }
                        else {
                            Rate = Item.UnitRate;
                            Weight = Item.Weight;
                            Pieces = Item.Pieces;
                        }

                        Purity = Item.StdPurity;
                        Studded = 0;

                        if (Purity == 0) {
                            let KaratId = Q.toId(Item.KaratId);
                            let purity: OMS.AttributeMasterRow;
                            OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                purity = response.Entity
                            }, { async: false });
                            let std = purity.StdPurity;
                            Purity = std;
                        }
                        break;
                    case 105:
                        if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && useCostRate == false) {
                            Rate = RateHelper.GetStoneSalesRate(Item.AttributeId, RateListId, Item.ProductId, Item.CostMethodId) / ExchangeRate;
                        }
                        else {
                            Rate = Item.UnitRate;
                            Weight = Item.Weight;
                            Pieces = Item.Pieces;
                        }
                        Studded = 0;
                        break;
                }
            }
            catch (undefined) {
                Q.notifyWarning("Rate not defined for " + Item.ProductCode);
            }

            // #endregion

            // #region FG
            if (Item.ItemTypeId == 101) {
                if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && useCostRate == false) {
                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                        ProductId: Item.ProductId,
                        AttributeId: Item.AttributeId,
                        RateListId: LaborListId,
                        Markup: LaborMarkup,
                        Pieces: Item.Pieces,
                        Weight: Item.Weight,
                        NetWeight: Item.NetWeight
                    }

                    let ItemLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt)
                    if (ItemLabor != null)
                        for (let i = 0; i < ItemLabor.length; i++) {
                            ItemLabor[i].LabourRate = ItemLabor[i].LabourRate / ExchangeRate;
                            ItemLabor[i].LabourAmount = ItemLabor[i].LabourAmount / ExchangeRate;
                            ItemLabor[i].CCLabourAmount = ItemLabor[i].LabourAmount;
                            LaborRate += ItemLabor[i].LabourAmount;
                            labordetail.push(ItemLabor[i]);
                        }
                }
                else {
                    if (Item.LaborDetails != null) {
                        labordetail = Item.LaborDetails;
                        if (labordetail.length > 0)
                            for (let i = 0; i < labordetail.length; i++) {
                                LaborRate += labordetail[i].LabourAmount;
                            }
                    }
                }


                if (!Item.HasBom) {

                    Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                    if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && useCostRate == false)
                        Rate = RateHelper.GetMetalRate(Item.MetalId, Item.KaratId, false, date) / ExchangeRate || 0;
                    else
                        Rate = Item.UnitRate;
                    if (Item.Purity == 0) {
                        let KaratId = Q.toId(Item.KaratId);
                        let purity: OMS.AttributeMasterRow;
                        OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                            purity = response.Entity
                        }, { async: false });
                        let std = purity.StdPurity;
                        Purity = std;
                    } else
                        Purity = Item.Purity
                }


                // #region ProductBOM
                if (Item.HasBom) {
                    Item.BOMDetails.forEach(function (ItemBOM) {
                        switch (ItemBOM.ItemTypeId) {
                            case 104:
                                if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && useCostRate == false)
                                    BOMRate = RateHelper.GetMetalRate(ItemBOM.ProductTypeId, ItemBOM.KaratId, false, date) / ExchangeRate;
                                else
                                    BOMRate = ItemBOM.BomRate;

                                let MetalBOMAmount = 0;
                                let UseKaratRate = (GetConfigValue(1014));
                                if (UseKaratRate == 'True')
                                    MetalBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) : ItemBOM.Weight * BOMRate;
                                else
                                    MetalBOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * ItemBOM.Purity * BOMRate;
                                Rate += MetalBOMAmount;


                                let Metal: Sales.SalesItemsBOMRow = {
                                    ProductId: ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    CategoryId: ItemBOM.CategoryId,
                                    SubCategoryId: ItemBOM.SubCategoryId,
                                    ProductTypeId: ItemBOM.ProductTypeId,
                                    BomRate: BOMRate,
                                    BomAmount: MetalBOMAmount,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: ItemBOM.CalcOn,
                                    Pieces: ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    ItemType: ItemBOM.ItemType,
                                    KaratId: ItemBOM.KaratId,
                                    MetalColorId: ItemBOM.MetalColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    Purity: ItemBOM.Purity,
                                    PureWeight: ItemBOM.PureWeight,
                                    RefTransBomId: ItemBOM.TransBomId,
                                    CCBomAmount: MetalBOMAmount * ExchangeRate,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    SettingId: 0,
                                    StoneStatusId: 1,
                                    PointerWeight: ItemBOM.PointerWeight == null ? 0 : ItemBOM.PointerWeight,
                                    TextureId: ItemBOM.TextureId == null ? 0 : ItemBOM.TextureId,
                                    Parts: ItemBOM.Parts == null ? 0 : ItemBOM.Parts

                                }
                                bomdetails.push(Metal);

                                break;

                            case 105:
                                if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && useCostRate == false)
                                    BOMRate = RateHelper.GetStoneSalesRate(ItemBOM.BOMAttributeId, RateListId, ItemBOM.BOMProductId, ItemBOM.CostMethodId, ItemBOM.Weight) / ExchangeRate;
                                else
                                    BOMRate = ItemBOM.BomRate;

                                let StoneBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) : (ItemBOM.Weight * BOMRate);
                                let StoneCCBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) * ExchangeRate : (ItemBOM.Weight * BOMRate) * ExchangeRate;

                                Rate += StoneBOMAmount;
                                if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && useCostRate == false) {
                                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                                        ProductId: ItemBOM.BOMProductId,
                                        AttributeId: ItemBOM.BOMAttributeId,
                                        RateListId: LaborListId,
                                        Markup: LaborMarkup,
                                        Pieces: ItemBOM.Pieces,
                                        Weight: ItemBOM.Weight,
                                        NetWeight: 0,
                                        SettingId: 0,
                                        IsCustomerItem: ItemBOM.IsCustomerItem
                                    }

                                    let ComponentLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt);
                                    if (ItemBOM.SettingId !== null && ItemBOM.SettingId > 0) {
                                        LaborOpt.SettingId = ItemBOM.SettingId;
                                        let SettingLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt);
                                        if (SettingLabor.length > 0)
                                            for (let setting of SettingLabor)
                                                ComponentLabor.push(setting);
                                    }
                                    if (ComponentLabor.length > 0) {
                                        for (let i = 0; i < ComponentLabor.length; i++) {
                                            ComponentLabor[i].LabourRate = ComponentLabor[i].LabourRate / ExchangeRate;
                                            ComponentLabor[i].LabourAmount = ComponentLabor[i].LabourAmount / ExchangeRate;
                                            ComponentLabor[i].CCLabourAmount = ComponentLabor[i].LabourAmount;
                                            LaborRate += ComponentLabor[i].LabourAmount;
                                            labordetail.push(ComponentLabor[i]);
                                        }
                                    }
                                }



                                let Stone: Sales.SalesItemsBOMRow = {
                                    ProductId: ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: StoneBOMAmount,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: ItemBOM.CalcOn,
                                    Pieces: ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemType: ItemBOM.ItemType,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    StoneColorId: ItemBOM.StoneColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    CategoryId: ItemBOM.CategoryId,
                                    SubCategoryId: ItemBOM.SubCategoryId,
                                    ProductTypeId: ItemBOM.ProductTypeId,
                                    QualityId: ItemBOM.QualityId,
                                    SieveId: ItemBOM.SieveId,
                                    ShapeId: ItemBOM.ShapeId,
                                    StoneSizeId: ItemBOM.StoneSizeId,
                                    SettingId: ItemBOM.SettingId == null ? 0 : ItemBOM.SettingId,
                                    GroupSieveId: ItemBOM.GroupSieveId,
                                    StoneCuletId: ItemBOM.StoneCuletId,
                                    StoneCutId: ItemBOM.StoneCutId,
                                    StoneFluorescenceId: ItemBOM.StoneFluorescenceId,
                                    StoneGirdleId: ItemBOM.StoneGirdleId,
                                    StonePolishId: ItemBOM.StonePolishId,
                                    StoneSymmetryId: ItemBOM.StoneSymmetryId,
                                    StoneDepth: ItemBOM.StoneDepth,
                                    StoneTable: ItemBOM.StoneTable,
                                    Lab: Item.Lab,
                                    RefTransBomId: ItemBOM.TransBomId,
                                    CCBomAmount: StoneBOMAmount * ExchangeRate,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    Purity: 0,
                                    PureWeight: 0,
                                    StoneStatusId: 1,
                                    PointerWeight: ItemBOM.PointerWeight == null ? 0 : ItemBOM.PointerWeight,
                                    TextureId: ItemBOM.TextureId == null ? 0 : ItemBOM.TextureId,
                                    Parts: ItemBOM.Parts == null ? 0 : ItemBOM.Parts

                                }
                                bomdetails.push(Stone);
                                break;
                        }
                    });
                }
                // #endregion
            }

            // #endregion

            // #region Amount Calculation
            if (Item.ItemTypeId == 101) {
                if (Item.HasBom) {
                    Cost = Rate + LaborRate;
                    Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : (Rate * Item.Weight) * Purity || 0;
                }
                else {
                    let UseKaratRate = (GetConfigValue(1021));

                    Cost = Rate + LaborRate + Item.StoneRate;
                    MetalAmount = UseKaratRate == 'True' ? Rate * Item.NetWeight : Rate * Item.NetWeight * Item.Purity;
                    Amount = Item.CalcOnId == 3 ? (MetalAmount + Item.StoneAmount + LaborRate) * Item.Pieces : (MetalAmount + Item.StoneAmount + LaborRate) || 0;
                }


            }
            else if (Item.ItemTypeId == 104) {
                Cost = Rate + LaborRate;
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : (Rate * Item.Weight) * Purity || 0;

            }
            else if (Item.ItemTypeId == 105) {
                Cost = Rate + LaborRate;
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : Rate * Item.Weight || 0;
            }
            Q.reloadLookup(OMS.DepartmentMasterRow.lookupKey);
            if (Item.DepartmentId != null || Item.DepartmentId > 0)
                OMS.DepartmentMasterService.Retrieve({ EntityId: Item.DepartmentId }, response => {
                    Location = response.Entity.DeptName
                }, { async: false });

            let SalesItem: Sales.SalesItemsRow = {
                ProductId: Item.ProductId,
                AttributeId: Item.AttributeId,
                Attribute: Item.Attribute,
                Line_No: Item.Line_No,
                PartyId: PartyId,
                SKU: Item.SKU,
                DepartmentId: Item.DepartmentId,
                DeptName: Item.DeptName,
                ProductCode: Item.ProductCode,
                ProductName: Item.ProductName,
                ItemTypeId: Item.ItemTypeId,
                HasBom: Item.HasBom,
                CategoryId: Item.CategoryId,
                ProductTypeId: Item.ProductTypeId,
                SubCategoryId: Item.SubCategoryId,
                BrandId: Item.BrandId,
                SuperTypeId: Item.SuperTypeId,
                CollectionId: Item.CollectionId,
                ProductSizeId: Item.ProductSizeId,
                UnitRate: Rate,
                UnitLabour: LaborRate,
                UnitCost: Cost,
                Pieces: Item.Pieces >= 0 ? Item.Pieces : 1,
                Weight: Item.Weight,
                MetalAmount: MetalAmount,
                PureWeight: Item.NetWeight * Item.Purity,
                OtherPieces: Item.OtherPieces,
                OtherWeight: Item.OtherWeight,
                StoneRate: Item.StoneRate == null ? 0 : Item.StoneRate,
                StoneAmount: Item.StoneAmount == null ? 0 : Item.StoneAmount,
                StonePieces: Item.StonePieces,
                StoneWeight: Item.StoneWeight,
                NetWeight: Item.NetWeight,
                NetAmount: Amount,
                GrossAmount: Amount,
                DiamondPieces: Item.DiamondPieces,
                DiamondWeight: Item.DiamondWeight,
                CalcOnId: Item.CalcOnId,
                BOMDetails: bomdetails,
                LaborDetails: labordetail,
                CompanyId: CompanyId,
                HSN: Item.HSN,
                TaxCode: Item.TaxCode,
                MetalId: Item.MetalId,
                KaratId: Item.ItemTypeId == 101 ? Item.KaratId : Item.KaratId,
                MetalColorId: Item.MetalColorId,
                QualityId: Item.QualityId,
                SieveId: Item.SieveId,
                ShapeId: Item.ShapeId,
                StoneColorId: Item.StoneColorId,
                StoneSizeId: Item.StoneSizeId,
                ImageName: Item.ImageName,
                Studded: Studded, // marking item as bulk
                StoneCutId: Item.StoneCutId,
                StonePolishId: Item.StonePolishId,
                StoneSymmetryId: Item.StoneSymmetryId,
                StoneFluorescenceId: Item.StoneFluorescenceId,
                StoneCuletId: Item.StoneCuletId,
                StoneGirdleId: Item.StoneGirdleId,
                StoneTable: Item.StoneTable,
                StoneDepth: Item.StoneDepth,
                Lab: Item.Lab,
                CertificateNo: Item.CertificateNo,
                Purity: Purity,
                LotNo: Item.LotNo,
                CalcUnitId: Item.CalcUnitId,
                RefVoucherId: Item.VoucherTypeId,
                RefTransId: Item.TransId,
                RefTransItemId: Item.TransItemId,
                CCGrossAmount: Amount * ExchangeRate,
                CCNetAmount: Amount * ExchangeRate,
                StockAllocation: Item.StockAllocation,
                BagNo: Item.BagNo,
                Hallmark: Item.Hallmark,
                Parts: Item.Parts,
                HUID: Item.HUID,
                StampId: Item.StampId,
                CostMethodId: Item.CostMethodId,
                MF: Item.MF,
                MFAmount: Item.MFAmount,
                RefNo: Item.RefNo,
                ExportPieces: Item.ExportPieces

            };

            ItemDetails.push(SalesItem);
        });

        return ItemDetails;
    }

    export function SetSalesOrderGrid(Items: any[], date: Date, PartyId: number, ExchangeRate: number, RateListId: number, LaborListId: number, LaborMarkup: number, MarkUpPolicyId: number, GenLine: boolean = true, IsDesign: boolean = false) {
        let ItemDetails = [];

        Items.forEach(function (Item) {
            // #region variables
            let CompanyId = Q.Authorization.userDefinition.CompanyId;
            let Rate = 0;
            let LaborRate = 0;
            let Pieces = 0;
            let Weight = 0;
            let BOMRate = 0;
            let Amount = 0;
            let Cost = 0;
            let Studded: number;
            let Purity = 0;
            let PurityDetails: OMS.AttributeMasterRow;
            let bomdetails = [];
            let labordetail = [];
            let Location: string;


            // #endregion

            // #region RM Rate
            try {
                switch (Item.ItemTypeId) {
                    case 104:
                        // TODO: Add Currency, Date, Rate Type
                        if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32) {
                            Rate = RateHelper.GetMetalRate(Item.ProductTypeId, Item.KaratId, false, date) / ExchangeRate;

                        }
                        else {
                            Rate = Item.UnitRate;
                            Weight = Item.Weight;
                            Pieces = Item.Pieces;
                        }

                        Purity = Item.StdPurity;
                        Studded = 0;

                        if (Purity == 0) {
                            let KaratId = Q.toId(Item.KaratId);
                            let purity: OMS.AttributeMasterRow;
                            OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                purity = response.Entity
                            }, { async: false });
                            let min = purity.MinPurity;
                            let max = purity.MaxPurity;
                            let std = purity.StdPurity;
                            Purity = PurityDetails.StdPurity
                        }
                        break;
                    case 105:
                        if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32) {
                            Rate = RateHelper.GetStoneSalesRate(Item.AttributeId, RateListId, Item.ProductId, Item.CostMethodId) / ExchangeRate;
                        }
                        else {
                            Rate = Item.UnitRate;
                            Weight = Item.Weight;
                            Pieces = Item.Pieces;
                        }
                        Studded = 0;
                        break;
                }
            }
            catch (undefined) {
                Q.notifyWarning("Rate not defined for " + Item.ProductCode);
            }

            // #endregion

            // #region FG     

            if (Item.ItemTypeId == 101) {
                if (Item.Line_No == null && GenLine == true)
                    Purchase.PurchaseMasterService.GetLineNo({}, response => Item.Line_No = response.Line_No, {
                        async: false
                    });



                if (!Item.HasBom) {

                    Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                    if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && Item.VoucherTypeId != 55)
                        Rate = RateHelper.GetMetalRate(Item.MetalId, Item.KaratId, true, date) / ExchangeRate;
                    else
                        Rate = Item.UnitRate;
                    if (Item.Purity == 0) {
                        let KaratId = Q.toId(Item.KaratId);
                        let purity: OMS.AttributeMasterRow;
                        OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                            purity = response.Entity
                        }, { async: false });
                        let std = purity.StdPurity;
                        Purity = std;
                    } else
                        Purity = Item.Purity
                }


                // #region ProductBOM
                if (Item.HasBom) {
                    Item.BOMDetails.forEach(function (ItemBOM) {
                        let CalcOn = OMS.FixedCodeRow.getLookup().itemById[ItemBOM.CalcOnId].FixedCode;
                        switch (ItemBOM.ItemTypeId) {
                            case 104:

                                if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && Item.VoucherTypeId != 55)
                                    BOMRate = RateHelper.GetMetalRate(ItemBOM.ProductTypeId, ItemBOM.KaratId, true, date) / ExchangeRate;
                                else
                                    BOMRate = ItemBOM.BomRate;

                                let metalmarkup = 0;
                                if (MarkUpPolicyId > 0) {
                                    let MetalMarkUpType = (GetConfigValue(1040));
                                    OMS.MarkupChargesService.GetMarkUp({
                                        ProductTypeId: ItemBOM.ProductTypeId,
                                        ItemTypeId: ItemBOM.ItemTypeId,
                                        CategoryId: ItemBOM.CategoryId,
                                        SubCategoryId: ItemBOM.SubCategoryId,
                                        KaratId: ItemBOM.KaratId,
                                        MetalColorId: ItemBOM.MetalColorId,
                                        MarkUpPolicyId: MarkUpPolicyId,
                                        MetalMarkUpType: parseInt(MetalMarkUpType),
                                        MarkUpType: 1
                                    },
                                        response => {
                                            if (response.Entity != null) {
                                                if (response.Entity.MarkUpRateType == 1) {
                                                    BOMRate = response.Entity.MarkUp;
                                                    metalmarkup = 1;
                                                } else if (response.Entity.MarkUpRateType == 2) {
                                                    metalmarkup = response.Entity.MarkUp;
                                                }
                                            }

                                        }, { async: false })


                                }
                                let MetalBOMAmount = 0;
                                let UseKaratRate = (GetConfigValue(1014));
                                if (UseKaratRate == 'True')
                                    MetalBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) : ItemBOM.Weight * BOMRate;
                                else
                                    MetalBOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * ItemBOM.Purity * BOMRate;



                                MetalBOMAmount = metalmarkup > 1 ? MetalBOMAmount * metalmarkup : MetalBOMAmount;
                                Rate += MetalBOMAmount;

                                let Metal: Sales.SalesItemsBOMRow = {
                                    ProductId: IsDesign ? ItemBOM.DesignId : ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    CategoryId: ItemBOM.CategoryId,
                                    SubCategoryId: ItemBOM.SubCategoryId,
                                    CategoryName: ItemBOM.CategoryName,
                                    SubCategoryName: ItemBOM.SubCategoryName,
                                    ProductTypeId: ItemBOM.ProductTypeId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: MetalBOMAmount,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: CalcOn,
                                    Pieces: ItemBOM.Pieces == null ? 0 : ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    ItemType: ItemBOM.ItemType,
                                    KaratId: ItemBOM.KaratId,
                                    MetalColorId: ItemBOM.MetalColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    Purity: ItemBOM.Purity,
                                    PureWeight: ItemBOM.Purity * ItemBOM.Weight,
                                    RefTransBomId: ItemBOM.TransBomId,
                                    CCBomAmount: MetalBOMAmount * ExchangeRate,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    Markup: metalmarkup,
                                    Parts: ItemBOM.Parts == null ? 1 : ItemBOM.Parts,
                                    SettingId: 0,
                                    StoneStatusId: 1,
                                    PointerWeight: ItemBOM.PointerWeight == null ? 0 : ItemBOM.PointerWeight,

                                }
                                if (IsDesign) {
                                    Metal["Volume"] = ItemBOM.Volume
                                    //Metal.BOMProductId = ItemBOM.BOMDesignId;
                                }
                                bomdetails.push(Metal);

                                break;
                            case 105:
                                ItemBOM.PointerWeight = ItemBOM.PointerWeight == null ? ItemBOM.Weight / ItemBOM.Pieces : ItemBOM.PointerWeight;
                                if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && Item.VoucherTypeId != 55 && ItemBOM.BOMAttributeId > 0)
                                    BOMRate = RateHelper.GetStoneSalesRate(ItemBOM.BOMAttributeId, RateListId, ItemBOM.BOMProductId, ItemBOM.CostMethodId, ItemBOM.PointerWeight) / ExchangeRate;
                                else if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && Item.VoucherTypeId != 55 && ItemBOM.BOMAttributeId == 0) {
                                    if (ItemBOM.Pieces > 0 && ItemBOM.PointerWeight == null)
                                        ItemBOM.PointerWeight = ItemBOM.Weight / ItemBOM.Pieces;

                                    let rateatb: RateHelper.RateAttributes = {
                                        ProductTypeId: ItemBOM.ProductTypeId,
                                        CategoryId: ItemBOM.CategoryId,
                                        SubCategoryId: ItemBOM.SubCategoryId,
                                        ShapeId: ItemBOM.ShapeId,
                                        SieveId: ItemBOM.SieveId,
                                        GroupSieveId: ItemBOM.GroupSieveId,
                                        StoneSizeId: ItemBOM.StoneSizeId,
                                        StoneColorId: ItemBOM.StoneColorId,
                                        QualityId: ItemBOM.QualityId,
                                        RateListId: RateListId,
                                        ProductId: ItemBOM.BOMProductId,
                                        CostMethodId: ItemBOM.CostMethodId,
                                        Weight: ItemBOM.PointerWeight
                                    }
                                    BOMRate = RateHelper.GetStoneSalesRatenoAtb(rateatb) / ExchangeRate;
                                }
                                else
                                    BOMRate = ItemBOM.BomRate;
                                let stonemarkup = 0;
                                if (MarkUpPolicyId > 0) {
                                    let StoneMarkUpType = (GetConfigValue(1039));

                                    OMS.MarkupChargesService.GetMarkUp({
                                        ProductTypeId: ItemBOM.ProductTypeId,
                                        ItemTypeId: ItemBOM.ItemTypeId,
                                        CategoryId: ItemBOM.CategoryId,
                                        SubCategoryId: ItemBOM.SubCategoryId,
                                        QualityId: ItemBOM.QualityId,
                                        StoneColorId: ItemBOM.StoneColorId,
                                        SieveId: ItemBOM.SieveId,
                                        StoneSizeId: ItemBOM.StoneSizeId,
                                        ShapeId: ItemBOM.ShapeId,
                                        MarkUpPolicyId: ItemBOM.MarkUpPolicyId,
                                        StoneMarkUpType: parseInt(StoneMarkUpType),
                                        MarkUpType: 1
                                    },
                                        response => {
                                            if (response.Entity != null) {
                                                if (response.Entity.MarkUpRateType == 1) {
                                                    BOMRate = response.Entity.MarkUp;
                                                    stonemarkup = 1;
                                                } else if (response.Entity.MarkUpRateType == 2) {
                                                    stonemarkup = response.Entity.MarkUp;
                                                }
                                            }
                                        }, { async: false })
                                }

                                let StoneBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) : (ItemBOM.Weight * BOMRate);
                                let StoneCCBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) * ExchangeRate : (ItemBOM.Weight * BOMRate) * ExchangeRate;

                                StoneBOMAmount = stonemarkup > 1 ? StoneBOMAmount * stonemarkup : StoneBOMAmount;
                                Rate += StoneBOMAmount;
                                if (Item.TransId == null && Item.VoucherTypeId != 55 && ItemBOM.BOMAttributeId > 0 || ItemBOM.BOMAttributeId > 0) {

                                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                                        ProductId: ItemBOM.BOMProductId,
                                        AttributeId: ItemBOM.BOMAttributeId,
                                        RateListId: LaborListId,
                                        Markup: LaborMarkup,
                                        Pieces: ItemBOM.Pieces,
                                        Weight: ItemBOM.PointerWeight,
                                        NetWeight: 0,
                                        SettingId: 0,
                                        IsCustomerItem: ItemBOM.IsCustomerItem
                                    }

                                    let ComponentLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt);
                                    if (ItemBOM.SettingId !== null && ItemBOM.SettingId > 0) {
                                        LaborOpt.SettingId = ItemBOM.SettingId;

                                        let SettingLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt);
                                        if (SettingLabor.length > 0)
                                            for (let setting of SettingLabor)
                                                ComponentLabor.push(setting);
                                    }
                                    if (ComponentLabor.length > 0) {
                                        for (let i = 0; i < ComponentLabor.length; i++) {
                                            ComponentLabor[i].LabourRate = ComponentLabor[i].LabourRate / ExchangeRate;
                                            ComponentLabor[i].LabourAmount = ComponentLabor[i].LabourAmount / ExchangeRate;
                                            ComponentLabor[i].CCLabourAmount = ComponentLabor[i].LabourAmount;
                                            LaborRate += ComponentLabor[i].LabourAmount;
                                            labordetail.push(ComponentLabor[i]);
                                        }
                                    }
                                }

                                let Stone: Sales.SalesItemsBOMRow = {
                                    ProductId: IsDesign ? ItemBOM.DesignId : ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: StoneBOMAmount,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: CalcOn,
                                    Pieces: ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemType: ItemBOM.ItemType,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    StoneColorId: ItemBOM.StoneColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    CategoryId: ItemBOM.CategoryId,
                                    SubCategoryId: ItemBOM.SubCategoryId,
                                    CategoryName: ItemBOM.CategoryName,
                                    SubCategoryName: ItemBOM.SubCategoryName,
                                    ProductTypeId: ItemBOM.ProductTypeId,
                                    QualityId: ItemBOM.QualityId,
                                    SieveId: ItemBOM.SieveId,
                                    ShapeId: ItemBOM.ShapeId,
                                    StoneSizeId: ItemBOM.StoneSizeId,
                                    SettingId: ItemBOM.SettingId == null ? 0 : ItemBOM.SettingId,
                                    GroupSieveId: ItemBOM.GroupSieveId,
                                    StoneCuletId: ItemBOM.StoneCuletId,
                                    StoneCutId: ItemBOM.StoneCutId,
                                    StoneFluorescenceId: ItemBOM.StoneFluorescenceId,
                                    StoneGirdleId: ItemBOM.StoneGirdleId,
                                    StonePolishId: ItemBOM.StonePolishId,
                                    StoneSymmetryId: ItemBOM.StoneSymmetryId,
                                    StoneDepth: ItemBOM.StoneDepth,
                                    StoneTable: ItemBOM.StoneTable,
                                    RefTransBomId: ItemBOM.TransBomId,
                                    CCBomAmount: StoneBOMAmount * ExchangeRate,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    PointerWeight: ItemBOM.PointerWeight == null ? 0 : ItemBOM.PointerWeight,
                                    Markup: stonemarkup,
                                    StoneStatusId: 1,
                                    Purity: 0,
                                    PureWeight: 0,
                                    Parts: 1,

                                }

                                //if (IsDesign) {
                                //    Stone.BOMProductId = ItemBOM.BOMDesignId;
                                //}

                                bomdetails.push(Stone);
                                break;
                        }
                    });
                }

                if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && Item.VoucherTypeId != 55 && Item.AttributeId > 0) {

                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                        ProductId: Item.ProductId,
                        AttributeId: Item.AttributeId,
                        RateListId: LaborListId,
                        Markup: LaborMarkup,
                        Pieces: Item.Pieces == null ? 1 : Item.Pieces,
                        Weight: Item.Weight,
                        NetWeight: Item.NetWeight,
                        DiamondWeight: Item.DiamondWeight,
                        StoneWeight: Item.StoneWeight,
                        DiamondPieces: Item.DiamondPieces,
                        StonePieces: Item.StonePieces,
                        Parts: Item.Parts
                    }

                    let ItemLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt);
                    if (ItemLabor.length > 0) {
                        for (let i = 0; i < ItemLabor.length; i++) {
                            if (MarkUpPolicyId > 0) {
                                let MetalMarkUpType = (GetConfigValue(1040));
                                OMS.MarkupChargesService.GetMarkUp({ ProcessId: ItemLabor[i].ProcessId, MarkUpType: 2, LaborMarkUpType: parseInt(MetalMarkUpType) },
                                    response => {
                                        if (response.Entity != null) {
                                            if (response.Entity.MarkUpRateType == 1) {
                                                ItemLabor[i].LabourRate = response.Entity.MarkUp;
                                                ItemLabor[i].MarkUp = 1;
                                            } else if (response.Entity.MarkUpRateType == 2) {
                                                ItemLabor[i].MarkUp = response.Entity.MarkUp;
                                            }
                                        }

                                    }, { async: false })
                            }
                            ItemLabor[i].LabourRate = ItemLabor[i].LabourRate / ExchangeRate;
                            ItemLabor[i].LabourAmount = ItemLabor[i].MarkUp > 0 ? (ItemLabor[i].LabourAmount * ItemLabor[i].MarkUp) / ExchangeRate :
                                ItemLabor[i].LabourAmount / ExchangeRate;

                            ItemLabor[i].CCLabourAmount = ItemLabor[i].LabourAmount;
                            LaborRate += ItemLabor[i].LabourAmount;



                            labordetail.push(ItemLabor[i]);
                        }
                    }
                }
                else {
                    if (Item.LaborDetails != null) {
                        labordetail = Item.LaborDetails;
                        if (labordetail.length > 0)
                            for (let i = 0; i < labordetail.length; i++) {
                                LaborRate += labordetail[i].LabourAmount;
                            }
                    }
                }
                // #endregion
            }

            // #endregion

            // #region Amount Calculation
            if (Item.ItemTypeId == 101) {
                Item.Pieces = Item.Pieces != 0 ? Item.Pieces : 1;
                Cost = Rate + LaborRate;
                Amount = Item.HasBom == true ? (Rate + LaborRate) * Item.Pieces : (Rate * Weight) * Purity || 0;
            }
            else if (Item.ItemTypeId == 104) {
                Item.Pieces = Item.Pieces != null ? Item.Pieces : 0;
                Cost = Rate + LaborRate;
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : (Rate * Weight) * Purity || 0;

            }
            else if (Item.ItemTypeId == 105) {
                Item.Pieces = Item.Pieces != null ? Item.Pieces : 0;
                Cost = Rate + LaborRate;
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : Rate * Weight || 0;
            }



            //Q.reloadLookup(OMS.DepartmentMasterRow.lookupKey);
            //if (Item.DepartmentId != null || Item.DepartmentId > 0)
            //    Location = OMS.DepartmentMasterRow.getLookup().itemById[Item.DepartmentId].DeptName;

            // #endregion
            if (Item.Pieces == null)
                Item.Pieces = 1;

            let SalesItem: Sales.SalesItemsRow = {
                DesignId: Item.DesignId,
                DesignCode: Item.DesignCode,
                ProductId: Item.ProductId,
                AttributeId: Item.AttributeId,
                Attribute: Item.Attribute,
                Line_No: Item.Line_No == null ? Item.LineNo : Item.Line_No,
                PartyId: PartyId,
                SKU: Item.SKU,
                DepartmentId: Item.DepartmentId,
                //DeptName: Item.DeptName,
                ProductCode: Item.ProductCode,
                ProductName: Item.ProductName,
                ItemTypeId: Item.ItemTypeId,
                HasBom: Item.HasBom,
                CategoryId: Item.CategoryId,
                ProductTypeId: Item.ProductTypeId,
                SubCategoryId: Item.SubCategoryId,
                BrandId: Item.BrandId,
                SuperTypeId: Item.SuperTypeId,
                CollectionId: Item.CollectionId,
                ProductSizeId: Item.ProductSizeId,
                UnitRate: Rate,
                UnitLabour: LaborRate,
                UnitCost: Cost,
                Pieces: Item.Pieces >= 0 ? Item.Pieces : 1,
                Weight: Item.Weight,
                OtherPieces: Item.OtherPieces,
                OtherWeight: Item.OtherWeight,
                StonePieces: Item.StonePieces,
                StoneWeight: Item.StoneWeight,
                NetWeight: Item.NetWeight,
                NetAmount: Amount,
                GrossAmount: Amount,
                DiamondPieces: Item.DiamondPieces,
                DiamondWeight: Item.DiamondWeight,
                CalcOnId: Item.CalcOnId,
                BOMDetails: bomdetails,
                LaborDetails: labordetail,
                CompanyId: CompanyId,
                HSN: Item.HSN,
                TaxCode: Item.TaxCode,
                MetalId: Item.MetalId,
                KaratId: Item.KaratId,
                MetalColorId: Item.MetalColorId,
                QualityId: Item.QualityId,
                SieveId: Item.SieveId,
                ShapeId: Item.ShapeId,
                StoneColorId: Item.StoneColorId,
                StoneSizeId: Item.StoneSizeId,
                ImageName: Item.ImageName,
                Studded: Studded, // marking item as bulk
                StoneCutId: Item.StoneCutId,
                StonePolishId: Item.StonePolishId,
                StoneSymmetryId: Item.StoneSymmetryId,
                StoneFluorescenceId: Item.StoneFluorescenceId,
                StoneCuletId: Item.StoneCuletId,
                StoneGirdleId: Item.StoneGirdleId,
                StoneTable: Item.StoneTable,
                StoneDepth: Item.StoneDepth,
                Purity: Purity,
                CalcUnitId: Item.CalcUnitId,
                PureWeight: Weight * Purity,
                RefVoucherId: Item.VoucherTypeId == null ? 0 : Item.VoucherTypeId,
                RefTransId: Item.TransId == null ? 0 : Item.TransId,
                RefTransItemId: Item.TransItemId == null ? 0 : Item.TransItemId,
                CCGrossAmount: Amount * ExchangeRate,
                CCNetAmount: Amount * ExchangeRate,
                BagNo: Item.BagNo,
                CertificateNo: Item.CertificateNo,
                Lab: Item.Lab,
                LotNo: Item.LotNo,
                Parts: Item.Parts,
                CostMethodId: Item.CostMethodId,
                RefNo: Item.RefNo,
                StampId: Item.StampId == null ? 0 : Item.StampId,
                SpecialRemark: Item.Remarks
            };
            if (IsDesign) {

                SalesItem["DesignId"] = Item.DesignId;
                SalesItem.DesignCode = Item.DesignCode;
                SalesItem["Iteration"] = Item.Iteration;
                SalesItem["SizeId"] = Item.SizeId;
                SalesItem["Image1"] = Item.Image1;
                SalesItem["Image2"] = Item.Image2;
                SalesItem["Image3"] = Item.Image3;
                SalesItem["Video1"] = Item.Video1;
                SalesItem["Video2"] = Item.Video2;
            }

            ItemDetails.push(SalesItem);

        });

        return ItemDetails;
    }

    export function SetReturnItemGrid(Items: any[]) {
        let ItemDetails = [];
        Items.forEach(function (Item) {
            let bomdetails = [];
            if (Item.HasBom) {
                for (let i = 0; i < Item.BOMDetails.length; i++) {
                    let ItemBOM = Item.BOMDetails[i];
                    if (ItemBOM.ItemTypeId == 104) {
                        let _bom: Sales.SalesItemsBOMRow = {
                            ProductId: ItemBOM.ProductId,
                            ProductCode: ItemBOM.ProductCode,
                            BOMProductId: ItemBOM.BOMProductId,
                            BOMAttributeId: ItemBOM.BOMAttributeId,
                            BomRate: ItemBOM.BomRate,
                            BomAmount: ItemBOM.BomAmount,
                            Remarks: ItemBOM.Remarks,
                            CalcOnId: ItemBOM.CalcOnId,
                            CalcOn: ItemBOM.CalcOn,
                            Pieces: ItemBOM.Pieces == null ? 0 : ItemBOM.Pieces,
                            Weight: ItemBOM.Weight,
                            ItemTypeId: ItemBOM.ItemTypeId,
                            ItemType: ItemBOM.ItemType,
                            ProductTypeId: ItemBOM.ProductTypeId,
                            CategoryId: ItemBOM.CategoryId,
                            SubCategoryId: ItemBOM.SubCategoryId,
                            KaratId: ItemBOM.KaratId,
                            MetalColorId: ItemBOM.MetalColorId,
                            Attribute: ItemBOM.Attribute,
                            CertificateNo: ItemBOM.CertificateNo,
                            Purity: ItemBOM.Purity,
                            PureWeight: ItemBOM.PureWeight == null ? ItemBOM.Purity * ItemBOM.Weight : ItemBOM.PureWeight,
                            RefTransBomId: ItemBOM.TransBomId,
                            CCBomAmount: ItemBOM.CCBomAmount,
                            IsCustomerItem: ItemBOM.IsCustomerItem,
                            CostMethodId: ItemBOM.CostMethodId,
                            SettingId: 0,
                            Parts: ItemBOM.Parts == null ? 1 : ItemBOM.Parts,
                            StoneStatusId: 1,
                            TextureId: ItemBOM.TextureId == null ? 0 : ItemBOM.TextureId,
                            PointerWeight: ItemBOM.PointerWeight == null ? 0 : ItemBOM.PointerWeight,

                        }
                        bomdetails.push(_bom);
                    }
                    else if (ItemBOM.ItemTypeId == 105) {
                        let _bom: Sales.SalesItemsBOMRow = {
                            ProductId: ItemBOM.ProductId,
                            ProductCode: ItemBOM.ProductCode,
                            BOMProductId: ItemBOM.BOMProductId,
                            BOMAttributeId: ItemBOM.BOMAttributeId,
                            BomRate: ItemBOM.BomRate,
                            BomAmount: ItemBOM.BomAmount,
                            Remarks: ItemBOM.Remarks,
                            CalcOnId: ItemBOM.CalcOnId,
                            CalcOn: ItemBOM.CalcOn,
                            Pieces: ItemBOM.Pieces,
                            Weight: ItemBOM.Weight,
                            ItemType: ItemBOM.ItemType,
                            ItemTypeId: ItemBOM.ItemTypeId,
                            StoneColorId: ItemBOM.StoneColorId,
                            Attribute: ItemBOM.Attribute,
                            CertificateNo: ItemBOM.CertificateNo,
                            CategoryId: ItemBOM.CategoryId,
                            SubCategoryId: ItemBOM.SubCategoryId,
                            ProductTypeId: ItemBOM.ProductTypeId,
                            QualityId: ItemBOM.QualityId,
                            SieveId: ItemBOM.SieveId,
                            ShapeId: ItemBOM.ShapeId,
                            StoneSizeId: ItemBOM.StoneSizeId,
                            SettingId: ItemBOM.SettingId == null ? 0 : ItemBOM.SettingId,
                            GroupSieveId: ItemBOM.GroupSieveId,
                            StoneCuletId: ItemBOM.StoneCuletId,
                            StoneCutId: ItemBOM.StoneCutId,
                            StoneFluorescenceId: ItemBOM.StoneFluorescenceId,
                            StoneGirdleId: ItemBOM.StoneGirdleId,
                            StonePolishId: ItemBOM.StonePolishId,
                            StoneSymmetryId: ItemBOM.StoneSymmetryId,
                            StoneDepth: ItemBOM.StoneDepth,
                            StoneTable: ItemBOM.StoneTable,
                            RefTransBomId: ItemBOM.TransBomId,
                            CCBomAmount: ItemBOM.CCBomAmount,
                            IsCustomerItem: ItemBOM.IsCustomerItem,
                            CostMethodId: ItemBOM.CostMethodId,
                            Purity: 0,
                            PureWeight: 0,
                            StoneStatusId: 1,
                            TextureId: 0
                        }
                        bomdetails.push(_bom);
                    }
                }
            }

            let ReturnItem: Sales.SalesReturnItemsRow = {
                VoucherNo: Item.VoucherNo,
                ProductId: Item.ProductId,
                AttributeId: Item.AttributeId,
                Line_No: Item.Line_No,
                PartyId: Item.PartyId,
                SKU: Item.SKU,
                DepartmentId: Item.DepartmentId,
                ProductCode: Item.ProductCode,
                ProductName: Item.ProductName,
                ItemTypeId: Item.ItemTypeId,
                CategoryId: Item.CategoryId,
                ProductTypeId: Item.ProductTypeId,
                SubCategoryId: Item.SubCategoryId,
                BrandId: Item.BrandId,
                SuperTypeId: Item.SuperTypeId,
                CollectionId: Item.CollectionId,
                ProductSizeId: Item.ProductSizeId,
                UnitRate: Item.UnitRate,
                UnitLabour: Item.UnitLabour,
                Pieces: Item.Pieces,
                Weight: Item.Weight,
                OtherPieces: Item.OtherPieces,
                OtherWeight: Item.OtherWeight,
                StonePieces: Item.StonePieces,
                StoneWeight: Item.StoneWeight,
                NetWeight: Item.NetWeight,
                NetAmount: Item.NetAmount,
                GrossAmount: Item.GrossAmount,
                DiamondPieces: Item.DiamondPieces,
                DiamondWeight: Item.DiamondWeight,
                CalcOnId: Item.CalcOnId,
                BOMDetails: bomdetails,
                LaborDetails: Item.LaborDetails,
                CompanyId: Item.CompanyId,
                HSN: Item.HSN,
                TaxCode: Item.TaxCode,
                AckStatus: Item.AckStatus,
                BagNo: Item.BagNo,
                BagStatus: Item.BagStatus,
                CertificateNo: Item.CertificateNo,
                DiamondAmount: Item.DiamondAmount,
                ImageName: Item.ImageName,
                LotNo: Item.LotNo,
                MetalAmount: Item.MetalAmount,
                OtherAmount: Item.OtherAmount,
                Remark: Item.Remark,
                SpecialRemark: Item.SpecialRemark,
                StoneAmount: Item.StoneAmount,
                UnitCost: Item.UnitCost,
                UserDescription: Item.UserDescription,
                VoucherDate: Item.VoucherDate,
                VoucherTypeId: Item.VoucherTypeId,
                WstPer: Item.WstPer,
                WstWt: Item.WstWt,
                Studded: Item.Studded,
                Discount: Item.Discount,
                DeliveryDate: Item.DeliveryDate,
                TransId: Item.TransId,
                TransItemId: Item.TransItemId,

                KaratId: Item.KaratId,
                MetalColorId: Item.MetalColorId,
                QualityId: Item.QualityId,
                SieveId: Item.SieveId,
                ShapeId: Item.ShapeId,
                StoneColorId: Item.StoneColorId,
                StoneSizeId: Item.StoneSizeId,

                StoneCutId: Item.StoneCutId,
                StonePolishId: Item.StonePolishId,
                StoneSymmetryId: Item.StoneSymmetryId,
                StoneFluorescenceId: Item.StoneFluorescenceId,
                StoneCuletId: Item.StoneCuletId,
                StoneGirdleId: Item.StoneGirdleId,
                StoneTable: Item.StoneTable,
                StoneDepth: Item.StoneDepth,
                Lab: Item.Lab,
                Purity: Item.Purity,
                PureWeight: Item.Pureweight,
                HasBom: Item.HasBom,
                RefNo: Item.RefNo,
                RefTransId: Item.TransId,
                RefTransItemId: Item.TransItemId,
                RefVoucherId: Item.VoucherTypeId,
                StockAllocation: Item.StockAllocation,
                HUID: Item.HUID,
                StampId: Item.StampId,
                CostMethodId: Item.CostMethodId,
                MF: Item.MF,
                MFAmount: Item.MFAmount,
                ExportPieces: Item.ExportPieces,
                Parts: Item.Parts
            }
            ItemDetails.push(ReturnItem);
        });

        return ItemDetails;
    }

    export function SetRetailItemGrid(Items: any[], date: Date, PartyId: number, ExchangeRate: number, RateListId: number, LaborListId: number, LaborMarkup: number) {
        let ItemDetails = [];
        if (ExchangeRate == null)
            ExchangeRate = 1;
        Items.forEach(function (Item: Retail.POSSalesItemsRow) {
            // #region variables
            let DeptId = 0;
            let CompanyId = Q.Authorization.userDefinition.CompanyId;
            let Rate = 0;
            let LaborRate = 0;
            let FancyCharges = 0;
            let OtherCharges = 0;
            let Pieces = 0;
            let Weight = 0;
            let BOMRate = 0;
            let Amount = 0;
            let Studded: number;
            let Purity = 0;
            let PurityDetails: OMS.AttributeMasterRow;
            let bomdetails = [];
            let labordetail = [];
            let GetSKUPrice = q.ToBool(GetConfigValue(1024));
            let GetCostPrice = q.ToBool(GetConfigValue(1031));
            let SplitLabor = q.ToBool(GetConfigValue(1033));
            let SKUDetail: Inventory.SKUItemsRow;

            // #endregion

            // #region RM Rate
            try {
                switch (Item.ItemTypeId) {
                    case 104:
                        // TODO: Add Currency, Date, Rate Type
                        if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47) {
                            Rate = RateHelper.GetMetalRate(Item.ProductTypeId, Item.KaratId, false, date) / ExchangeRate;
                        }
                        else {
                            Rate = Item.UnitRate;
                            Weight = Item.Weight;
                            Pieces = Item.Pieces;
                        }

                        Purity = Item.Purity;
                        Studded = 0;

                        if (Purity == 0) {
                            let KaratId = Q.toId(Item.KaratId);
                            let purity: OMS.AttributeMasterRow;
                            OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                purity = response.Entity
                            }, { async: false });
                            let std = purity.StdPurity;
                            Purity = std;
                        }
                        break;
                    case 105:
                        if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47) {
                            Rate = RateHelper.GetStoneSalesRate(Item.AttributeId, RateListId, Item.ProductId, Item.CostMethodId) / ExchangeRate;
                        }
                        else {
                            Rate = Item.UnitRate;
                        }
                        Studded = 0;
                        break;
                }
            }
            catch (undefined) {
                Q.notifyWarning("Rate not defined for " + Item.ProductCode);
            }

            // #endregion

            // #region FG
            if (Item.ItemTypeId == 101) {

                if (GetSKUPrice && !Q.isEmptyOrNull(Item.SKU)) {

                    Inventory.SKUItemsService.GetSKUDetails({ SKU: Item.SKU, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });

                    if (SKUDetail == null)
                        Inventory.SKUSplittingItemsService.GetSKUDetails({ SKU: Item.SKU, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });
                    if (SKUDetail == null)
                        Purchase.PurchaseItemsService.GetItemDetails({ SKU: Item.SKU, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });
                    if (SKUDetail == null)
                        Purchase.ApprovalInItemsService.GetItemDetails({ SKU: Item.SKU, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });

                }

                if (GetCostPrice && Item.Line_No != null) {
                    if (SKUDetail == null)
                        Purchase.PurchaseItemsService.GetItemDetails({ ProductId: Item.ProductId, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });
                    if (SKUDetail == null)
                        Purchase.ApprovalInItemsService.GetItemDetails({ ProductId: Item.ProductId, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });
                    if (SKUDetail == null)
                        Inventory.OpeningStockItemsService.GetItemDetails({ ProductId: Item.ProductId, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });
                }

                //if (Item.Line_No == null && GenLineNo)
                //    Purchase.PurchaseMasterService.GetLineNo({}, response => Item.Line_No = response.Line_No, {
                //        async: false
                //    });
                //Pieces = 1;
                Weight = Item.Weight == 0 ? 1 : Item.Weight;
                if (Item.Pieces == null || Item.Pieces == 0)
                    Item.Pieces = 1;
                if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47 && SKUDetail == null) {
                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                        ProductId: Item.ProductId,
                        AttributeId: Item.AttributeId,
                        RateListId: LaborListId,
                        Markup: LaborMarkup,
                        Pieces: Item.Pieces,
                        Weight: Item.Weight,
                        NetWeight: Item.NetWeight
                    }
                    let ItemLabor: Retail.POSSalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt)
                    if (ItemLabor.length > 0)
                        for (let labor of ItemLabor) {
                            LaborRate += labor.LabourAmount;
                            labor.OriginalLabourRate = labor.LabourRate;
                            labor.OriginalLabourAmount = labor.LabourAmount;
                            labordetail.push(labor);
                        }
                }
                else if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47 && SKUDetail != null) {
                    if (SKUDetail.LaborDetails != null) {
                        for (let xlabor of SKUDetail.LaborDetails) {

                            if (SplitLabor) {
                                let discount = xlabor.Discount == undefined ? 0 : xlabor.Discount;
                                switch (xlabor.CalculateTo) {
                                    case 1:

                                        LaborRate += xlabor.LabourAmount - discount
                                        break;
                                    case 2:
                                        FancyCharges += xlabor.LabourAmount - discount;
                                        break;
                                    case 3:
                                        OtherCharges += xlabor.LabourAmount - discount;
                                        break;
                                }
                            }
                            else {
                                LaborRate += xlabor.LabourAmount;
                            }

                            let _labor: Retail.POSSalesLaborRow = {
                                AttributeId: xlabor.AttributeId,
                                ProductTypeId: xlabor.ProductTypeId,
                                ProductTypeName: xlabor.ProductTypeName,
                                ProcessId: xlabor.ProcessId,
                                ProcessName: xlabor.ProcessName,
                                LabourRate: xlabor.LabourRate,
                                LabourAmount: xlabor.LabourAmount,
                                CCLabourAmount: xlabor.CCLabourAmount,
                                CalcOnId: xlabor.CalcOnId,
                                Weight: xlabor.Weight,
                                Pieces: xlabor.Pieces,
                                IsCustomerItem: xlabor.IsCustomerItem,
                                CalculateTo: xlabor.CalculateTo
                            }

                            labordetail.push(_labor);
                        }
                    }
                }
                else {
                    labordetail = Item.LaborDetails;
                    for (let ylabor of labordetail) {
                        LaborRate += ylabor.LabourAmount;
                    }
                }


                if (!Item.HasBom) {

                    Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                    if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47)
                        Rate = RateHelper.GetMetalRate(Item.MetalId, Item.KaratId, false, date);
                    else
                        Rate = Item.UnitRate;
                    if (Item.Purity == 0) {
                        let KaratId = Q.toId(Item.KaratId);
                        let purity: OMS.AttributeMasterRow;
                        OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                            purity = response.Entity
                        }, { async: false });
                        let std = purity.StdPurity;
                        Purity = std;
                    } else
                        Purity = Item.Purity
                }


                // #region ProductBOM
                if (Item.HasBom) {
                    Item.BOMDetails.forEach(function (ItemBOM) {
                        switch (ItemBOM.ItemTypeId) {
                            case 104:
                                BOMRate = 0;
                                if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47)
                                    BOMRate = RateHelper.GetMetalRate(ItemBOM.ProductTypeId, ItemBOM.KaratId, true, date);
                                else
                                    BOMRate = ItemBOM.BomRate;

                                let MetalBOMAmount = 0;
                                let UseKaratRate = q.ToBool(GetConfigValue(1014));

                                if (UseKaratRate == true)
                                    MetalBOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * BOMRate;
                                else
                                    MetalBOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * ItemBOM.Purity * BOMRate;
                                Rate += MetalBOMAmount;

                                let Metal: Retail.POSSalesItemsBOMRow = {
                                    ProductId: ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: MetalBOMAmount,
                                    CCBomAmount: MetalBOMAmount * ExchangeRate,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: ItemBOM.CalcOn,
                                    Pieces: ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    ItemType: ItemBOM.ItemType,
                                    KaratId: ItemBOM.KaratId,
                                    MetalColorId: ItemBOM.MetalColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    Purity: ItemBOM.Purity,
                                    PureWeight: ItemBOM.Purity * ItemBOM.Weight == null ? 0 : ItemBOM.Purity * ItemBOM.Weight,
                                    RefTransBomId: ItemBOM.TransBomId,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    CategoryName: ItemBOM.CategoryName,
                                    SubCategoryName: ItemBOM.SubCategoryName,
                                    TextureId: ItemBOM.TextureId == null ? 0 : ItemBOM.TextureId,
                                    Parts: ItemBOM.Parts == null ? 1 : ItemBOM.Parts,
                                    PointerWeight: ItemBOM.PointerWeight == null ? 0 : ItemBOM.PointerWeight,


                                }
                                bomdetails.push(Metal);
                                break;
                            case 105:
                                BOMRate = 0;
                                if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47) {
                                    if (SKUDetail != null) {
                                        let SKUBom = Q.tryFirst(SKUDetail.BOMDetails, x => x.BOMAttributeId == ItemBOM.BOMAttributeId && x.BOMProductId == ItemBOM.BOMProductId);
                                        if (ItemBOM.CostMethodId == 9) {
                                            BOMRate = RateHelper.GetStoneSalesRate(ItemBOM.BOMAttributeId, RateListId, ItemBOM.BOMProductId, ItemBOM.CostMethodId, ItemBOM.Weight);
                                            if (BOMRate == 0)
                                                BOMRate = SKUBom.SBomRate == 0 ? SKUBom.BomRate : SKUBom.SBomRate;
                                        }
                                        else {
                                            if (GetCostPrice)
                                                BOMRate = SKUBom.BomRate;
                                            else
                                                BOMRate = RateHelper.GetStoneSalesRate(ItemBOM.BOMAttributeId, RateListId, ItemBOM.BOMProductId, ItemBOM.CostMethodId, ItemBOM.Weight);
                                        }

                                    }
                                    else {
                                        BOMRate = RateHelper.GetStoneSalesRate(ItemBOM.BOMAttributeId, RateListId, ItemBOM.BOMProductId, ItemBOM.CostMethodId, ItemBOM.Weight);
                                    }
                                }
                                else {
                                    BOMRate = ItemBOM.BomRate;
                                }

                                let StoneBOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * BOMRate;
                                Rate += StoneBOMAmount;
                                if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47 && SKUDetail == null) {

                                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                                        ProductId: ItemBOM.BOMProductId,
                                        AttributeId: ItemBOM.BOMAttributeId,
                                        RateListId: LaborListId,
                                        Markup: LaborMarkup,
                                        Pieces: ItemBOM.Pieces,
                                        Weight: ItemBOM.Weight,
                                        NetWeight: 0,
                                        SettingId: 0,
                                        IsCustomerItem: ItemBOM.IsCustomerItem
                                    }

                                    let ComponentLabor: Retail.POSSalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt);
                                    if (ItemBOM.SettingId !== null && ItemBOM.SettingId > 0) {
                                        LaborOpt.SettingId = ItemBOM.SettingId;
                                        let SettingLabor: Retail.POSSalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt);
                                        if (SettingLabor.length > 0)
                                            for (let setting of SettingLabor)
                                                ComponentLabor.push(setting);
                                    }
                                    if (ComponentLabor.length > 0) {
                                        for (let i = 1; i < ComponentLabor.length; i++) {
                                            LaborRate += ComponentLabor[i].LabourAmount;
                                            ComponentLabor[i].OriginalLabourRate = ComponentLabor[i].LabourRate;
                                            ComponentLabor[i].OriginalLabourAmount = ComponentLabor[i].LabourAmount;
                                            labordetail.push(ComponentLabor[i]);
                                        }
                                    }
                                }

                                let Stone: Retail.POSSalesItemsBOMRow = {
                                    ProductId: ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: StoneBOMAmount,
                                    CCBomAmount: StoneBOMAmount * ExchangeRate,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: ItemBOM.CalcOn,
                                    Pieces: ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemType: ItemBOM.ItemType,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    StoneColorId: ItemBOM.StoneColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    CategoryId: ItemBOM.CategoryId,
                                    SubCategoryId: ItemBOM.SubCategoryId,
                                    ProductTypeId: ItemBOM.ProductTypeId,
                                    QualityId: ItemBOM.QualityId,
                                    SieveId: ItemBOM.SieveId,
                                    ShapeId: ItemBOM.ShapeId,
                                    StoneSizeId: ItemBOM.StoneSizeId,
                                    SettingId: ItemBOM.SettingId == null ? 0 : ItemBOM.SettingId,
                                    GroupSieveId: ItemBOM.GroupSieveId,
                                    StoneCuletId: ItemBOM.StoneCuletId,
                                    StoneCutId: ItemBOM.StoneCutId,
                                    StoneFluorescenceId: ItemBOM.StoneFluorescenceId,
                                    StoneGirdleId: ItemBOM.StoneGirdleId,
                                    StonePolishId: ItemBOM.StonePolishId,
                                    StoneSymmetryId: ItemBOM.StoneSymmetryId,
                                    StoneDepth: ItemBOM.StoneDepth,
                                    StoneTable: ItemBOM.StoneTable,
                                    RefTransBomId: ItemBOM.TransBomId,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    StoneStatusId: 1,
                                    CategoryName: ItemBOM.CategoryName,
                                    SubCategoryName: ItemBOM.SubCategoryName,
                                    PureWeight: 0,
                                    TextureId: ItemBOM.TextureId == null ? 0 : ItemBOM.TextureId,
                                    Parts: ItemBOM.Parts == null ? 1 : ItemBOM.Parts

                                }
                                bomdetails.push(Stone)

                                break;

                        }
                    });
                }
                // #endregion
            }

            // #endregion

            // #region Amount Calculation
            if (Item.ItemTypeId == 101) {
                Amount = Item.HasBom ? (Rate + LaborRate) * Item.Pieces : (Rate * Weight) * Purity || 0;
            }
            else if (Item.ItemTypeId == 104) {

                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : (Rate * Weight) * Purity || 0;

            }
            else if (Item.ItemTypeId == 105) {
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : Rate * Weight || 0;
            }
            // #endregion
            if (Item.Pieces == null)
                Item.Pieces = 1;

            let SalesItem: Retail.POSSalesItemsRow = {
                ProductId: Item.ProductId,
                AttributeId: Item.AttributeId,
                Attribute: Item.Attribute,
                Line_No: Item.Line_No,
                PartyId: PartyId,
                SKU: Item.SKU,
                DepartmentId: Item.DepartmentId,
                DeptName: Item.DeptName,
                ProductCode: Item.ProductCode,
                ProductName: Item.ProductName,
                ItemTypeId: Item.ItemTypeId,
                HasBom: Item.HasBom,
                CategoryId: Item.CategoryId,
                ProductTypeId: Item.ProductTypeId,
                SubCategoryId: Item.SubCategoryId,
                BrandId: Item.BrandId,
                SuperTypeId: Item.SuperTypeId,
                CollectionId: Item.CollectionId,
                ProductSizeId: Item.ProductSizeId,
                UnitRate: Rate,
                UnitLabour: LaborRate,
                FancyCharges: FancyCharges,
                OtherCharges: OtherCharges,
                Pieces: Item.Pieces,
                Weight: Item.Weight,
                OtherPieces: Item.OtherPieces,
                OtherWeight: Item.OtherWeight,
                StonePieces: Item.StonePieces,
                StoneWeight: Item.StoneWeight,
                NetWeight: Item.NetWeight,
                NetAmount: Amount,
                GrossAmount: Amount,
                DiamondPieces: Item.DiamondPieces,
                DiamondWeight: Item.DiamondWeight,
                CalcOnId: Item.CalcOnId,
                BOMDetails: bomdetails,
                LaborDetails: labordetail,
                CompanyId: CompanyId,
                HSN: Item.HSN,
                TaxCode: Item.TaxCode,
                MetalId: Item.MetalId,
                KaratId: Item.KaratId,
                MetalColorId: Item.MetalColorId,
                QualityId: Item.QualityId,
                SieveId: Item.SieveId,
                ShapeId: Item.ShapeId,
                StoneColorId: Item.StoneColorId,
                StoneSizeId: Item.StoneSizeId,
                ImageName: Item.ImageName,
                Studded: Item.Studded, // marking item as bulk
                StoneCutId: Item.StoneCutId,
                StonePolishId: Item.StonePolishId,
                StoneSymmetryId: Item.StoneSymmetryId,
                StoneFluorescenceId: Item.StoneFluorescenceId,
                StoneCuletId: Item.StoneCuletId,
                StoneGirdleId: Item.StoneGirdleId,
                StoneTable: Item.StoneTable,
                StoneDepth: Item.StoneDepth,
                Lab: Item.Lab,
                CertificateNo: Item.CertificateNo,
                Purity: Purity,
                LotNo: Item.LotNo,
                CalcUnitId: Item.CalcUnitId,
                PureWeight: Weight * Purity,
                RefVoucherId: Item.VoucherTypeId,
                RefTransId: Item.TransId,
                RefTransItemId: Item.TransItemId,
                Parts: Item.Parts,
                BagNo: Item.BagNo,
                HUID: Item.HUID,
                StampId: Item.StampId,
                MF: Item.MF,
                MFAmount: Item.MFAmount,
                ExportPieces: Item.ExportPieces
            };

            ItemDetails.push(SalesItem);
        });

        return ItemDetails;
    }

    export function SetEcommerceInvoiceItem(Items: any[], ECommOrderItemId: number) {
        let ItemDetails = [];
        Items.forEach(function (Item) {
            // #region variables
            let DeptId = 0;
            let CompanyId = Q.Authorization.userDefinition.CompanyId;
            let Rate = 0;
            let LaborRate = 0;
            let FancyCharges = 0;
            let OtherCharges = 0;
            let Pieces = 0;
            let Weight = 0;
            let BOMRate = 0;
            let Amount = 0;
            let Studded: number;
            let Purity = 0;
            let PurityDetails: OMS.AttributeMasterRow;
            let bomdetails = [];
            let labordetail = [];
            let SKUDetail: Inventory.SKUItemsRow;

            // #endregion


            // #region FG
            if (Item.ItemTypeId == 101) {

                ECommerce.ECommOrderItemsService.List({ ProductId: Item.ProductId, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });

                Weight = Item.Weight == 0 ? 1 : Item.Weight;
                if (Item.Pieces == null || Item.Pieces == 0)
                    Item.Pieces = 1;


                // #region ProductBOM
                if (Item.HasBom) {
                    Item.BOMDetails.forEach(function (ItemBOM) {
                        let SKUBom = Q.tryFirst(SKUDetail.BOMDetails, x => x.BOMAttributeId == ItemBOM.BOMAttributeId && x.BOMProductId == ItemBOM.BOMProductId);

                        switch (ItemBOM.ItemTypeId) {
                            case 104:
                                BOMRate = 0;
                                BOMRate = SKUBom.BomRate;

                                let MetalBOMAmount = 0;
                                let UseKaratRate = q.ToBool(GetConfigValue(1014));

                                if (UseKaratRate == true)
                                    MetalBOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * BOMRate;
                                else
                                    MetalBOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * ItemBOM.Purity * BOMRate;
                                Rate += MetalBOMAmount;

                                let Metal: Retail.POSSalesItemsBOMRow = {
                                    ProductId: ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: MetalBOMAmount,
                                    //CCBomAmount: MetalBOMAmount * 1,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: ItemBOM.CalcOn,
                                    Pieces: ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    ItemType: ItemBOM.ItemType,
                                    KaratId: ItemBOM.KaratId,
                                    MetalColorId: ItemBOM.MetalColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    Purity: ItemBOM.Purity,
                                    PureWeight: ItemBOM.PureWeight,
                                    RefTransBomId: ItemBOM.TransBomId,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    CategoryName: ItemBOM.CategoryName,
                                    SubCategoryName: ItemBOM.SubCategoryName,
                                    TextureId: ItemBOM.TextureId == null ? 0 : ItemBOM.TextureId,
                                    Parts: ItemBOM.Parts == null ? 1 : ItemBOM.Parts,
                                    PointerWeight: ItemBOM.PointerWeight == null ? 0 : ItemBOM.PointerWeight,

                                }
                                bomdetails.push(Metal);
                                break;
                            case 105:
                                BOMRate = 0;
                                BOMRate = SKUBom.BomRate;
                                let StoneBOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * BOMRate;
                                Rate += StoneBOMAmount;

                                let Stone: Retail.POSSalesItemsBOMRow = {
                                    ProductId: ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: StoneBOMAmount,
                                    //CCBomAmount: StoneBOMAmount * 1,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: ItemBOM.CalcOn,
                                    Pieces: ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemType: ItemBOM.ItemType,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    StoneColorId: ItemBOM.StoneColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    CategoryId: ItemBOM.CategoryId,
                                    SubCategoryId: ItemBOM.SubCategoryId,
                                    ProductTypeId: ItemBOM.ProductTypeId,
                                    QualityId: ItemBOM.QualityId,
                                    SieveId: ItemBOM.SieveId,
                                    ShapeId: ItemBOM.ShapeId,
                                    StoneSizeId: ItemBOM.StoneSizeId,
                                    SettingId: ItemBOM.SettingId == null ? 0 : ItemBOM.SettingId,
                                    GroupSieveId: ItemBOM.GroupSieveId,
                                    StoneCuletId: ItemBOM.StoneCuletId,
                                    StoneCutId: ItemBOM.StoneCutId,
                                    StoneFluorescenceId: ItemBOM.StoneFluorescenceId,
                                    StoneGirdleId: ItemBOM.StoneGirdleId,
                                    StonePolishId: ItemBOM.StonePolishId,
                                    StoneSymmetryId: ItemBOM.StoneSymmetryId,
                                    StoneDepth: ItemBOM.StoneDepth,
                                    StoneTable: ItemBOM.StoneTable,
                                    RefTransBomId: ItemBOM.TransBomId,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    StoneStatusId: 1,
                                    CategoryName: ItemBOM.CategoryName,
                                    SubCategoryName: ItemBOM.SubCategoryName,
                                    PureWeight: 0,
                                    TextureId: ItemBOM.TextureId == null ? 0 : ItemBOM.TextureId,
                                    Parts: ItemBOM.Parts == null ? 1 : ItemBOM.Parts

                                }
                                bomdetails.push(Stone)

                                break;

                        }
                    });

                    if (SKUDetail.LaborDetails != null)
                        SKUDetail.LaborDetails.forEach(function (labor) {
                            LaborRate += labor.LabourAmount;
                        })
                }
                // #endregion
            }

            // #endregion

            // #region Amount Calculation
            if (Item.ItemTypeId == 101) {
                Amount = Item.HasBom ? (Rate + LaborRate) * Item.Pieces : (Rate * Weight) * Purity || 0;
            }
            else if (Item.ItemTypeId == 104) {

                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : (Rate * Weight) * Purity || 0;

            }
            else if (Item.ItemTypeId == 105) {
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : Rate * Weight || 0;
            }
            // #endregion
            if (Item.Pieces == null)
                Item.Pieces = 1;

            let SalesItem: Retail.POSSalesItemsRow = {
                ProductId: Item.ProductId,
                AttributeId: Item.AttributeId,
                Attribute: Item.Attribute,
                Line_No: Item.Line_No,
                PartyId: 1,
                SKU: Item.SKU,
                DepartmentId: Item.DepartmentId,
                DeptName: Item.DeptName,
                ProductCode: Item.ProductCode,
                ProductName: Item.ProductName,
                ItemTypeId: Item.ItemTypeId,
                HasBom: Item.HasBom,
                CategoryId: Item.CategoryId,
                ProductTypeId: Item.ProductTypeId,
                SubCategoryId: Item.SubCategoryId,
                BrandId: Item.BrandId,
                SuperTypeId: Item.SuperTypeId,
                CollectionId: Item.CollectionId,
                ProductSizeId: Item.ProductSizeId,
                UnitRate: Rate,
                UnitLabour: LaborRate,
                FancyCharges: FancyCharges,
                OtherCharges: OtherCharges,
                Pieces: Item.Pieces,
                Weight: Item.Weight,
                OtherPieces: Item.OtherPieces,
                OtherWeight: Item.OtherWeight,
                StonePieces: Item.StonePieces,
                StoneWeight: Item.StoneWeight,
                NetWeight: Item.NetWeight,
                NetAmount: Amount,
                GrossAmount: Amount,
                DiamondPieces: Item.DiamondPieces,
                DiamondWeight: Item.DiamondWeight,
                CalcOnId: Item.CalcOnId,
                BOMDetails: bomdetails,
                LaborDetails: SKUDetail.LaborDetails,
                CompanyId: CompanyId,
                HSN: Item.HSN,
                TaxCode: Item.TaxCode,
                MetalId: Item.MetalId,
                KaratId: Item.KaratId,
                MetalColorId: Item.MetalColorId,
                QualityId: Item.QualityId,
                SieveId: Item.SieveId,
                ShapeId: Item.ShapeId,
                StoneColorId: Item.StoneColorId,
                StoneSizeId: Item.StoneSizeId,
                ImageName: Item.ImageName,
                Studded: Item.Studded, // marking item as bulk
                StoneCutId: Item.StoneCutId,
                StonePolishId: Item.StonePolishId,
                StoneSymmetryId: Item.StoneSymmetryId,
                StoneFluorescenceId: Item.StoneFluorescenceId,
                StoneCuletId: Item.StoneCuletId,
                StoneGirdleId: Item.StoneGirdleId,
                StoneTable: Item.StoneTable,
                StoneDepth: Item.StoneDepth,
                Lab: Item.Lab,
                CertificateNo: Item.CertificateNo,
                Purity: Purity,
                LotNo: Item.LotNo,
                CalcUnitId: Item.CalcUnitId,
                PureWeight: Weight * Purity,
                RefVoucherId: Item.VoucherTypeId,
                RefTransId: Item.TransId,
                RefTransItemId: Item.TransItemId,
                Parts: Item.Parts,
                BagNo: Item.BagNo,
                //HUID: Item.HUID,
                StampId: Item.StampId,
                MF: Item.MF,
                MFAmount: Item.MFAmount,
                ExportPieces: Item.ExportPieces,

            };

            ItemDetails.push(SalesItem);
        });

        return ItemDetails;
    }


    export function SetTransferItemGrid(Items: any[], date: Date, PartyId: number, ExchangeRate: number, RateListId: number, LaborListId: number, LaborMarkup: number) {
        let ItemDetails = [];

        let useCostRate = q.ToBool(GetConfigValue(1023));
        Items.forEach(function (Item) {
            // #region variables
            let CompanyId = Q.Authorization.userDefinition.CompanyId;
            let Rate = 0;
            let LaborRate = 0;
            let Pieces = 0;
            let Weight = 0;
            let BOMRate = 0;
            let Amount = 0;
            let Cost = 0;
            let Studded: number;
            let Purity = 0;
            let PurityDetails: OMS.AttributeMasterRow;
            let bomdetails = [];
            let labordetail = [];
            let Location: string;
            let SKUDetail: Inventory.SKUItemsRow;


            // #endregion

            // #region RM Rate
            try {
                switch (Item.ItemTypeId) {
                    case 104:
                        // TODO: Add Currency, Date, Rate Type
                        if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && useCostRate) {
                            //Rate = RateHelper.GetMetalRate(Item.ProductTypeId, Item.KaratId, false, date) / ExchangeRate;
                            Stock.StockItemService.GetWeightedAVGRate(
                                {
                                    ItemTypeId: 104, ProductTypeId: Item.ProductTypeId
                                },
                                response => Rate = response.Rate / ExchangeRate,
                                {
                                    async: false
                                }
                            );
                        }
                        else {
                            Rate = Item.UnitRate;
                            Weight = Item.Weight;
                            Pieces = Item.Pieces;
                        }

                        Purity = Item.StdPurity;
                        Studded = 0;

                        if (Purity == 0) {
                            let KaratId = Q.toId(Item.KaratId);
                            let purity: OMS.AttributeMasterRow;
                            OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                purity = response.Entity
                            }, { async: false });
                            let std = purity.StdPurity;
                            Purity = std;
                        }
                        break;
                    case 105:
                        if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && useCostRate) {
                            Rate = RateHelper.GetStoneSalesRate(Item.BOMAttributeId, RateListId, Item.BOMProductId, Item.CostMethodId) / ExchangeRate;
                        }
                        else {
                            Rate = Item.UnitRate;
                            Weight = Item.Weight;
                            Pieces = Item.Pieces;
                        }
                        Studded = 0;
                        break;
                }
            }
            catch (undefined) {
                Q.notifyWarning("Rate not defined for " + Item.ProductCode);
            }

            // #endregion

            // #region FG
            if (Item.ItemTypeId == 101) {

                if (useCostRate && Item.Line_No != null) {
                    if (SKUDetail == null)
                        Inventory.SKURepricingItemsService.GetItemDetails({ ProductId: Item.ProductId, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });
                    if (SKUDetail == null)
                        Purchase.PurchaseItemsService.GetItemDetails({ ProductId: Item.ProductId, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });
                    if (SKUDetail == null)
                        Purchase.ApprovalInItemsService.GetItemDetails({ ProductId: Item.ProductId, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });
                    if (SKUDetail == null)
                        Inventory.OpeningStockItemsService.GetItemDetails({ ProductId: Item.ProductId, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });
                }


                if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && useCostRate == false) {
                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                        ProductId: Item.ProductId,
                        AttributeId: Item.AttributeId,
                        RateListId: LaborListId,
                        Markup: LaborMarkup,
                        Pieces: Item.Pieces,
                        Weight: Item.Weight,
                        NetWeight: Item.NetWeight
                    }

                    let ItemLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt)
                    if (ItemLabor.length > 0)
                        for (let a of ItemLabor) {
                            a.LabourRate = a.LabourRate / ExchangeRate;
                            a.LabourAmount = a.LabourAmount / ExchangeRate;
                            a.CCLabourAmount = a.LabourAmount;
                            LaborRate += a.LabourAmount;
                            labordetail.push(a);
                        }
                }
                else {
                    if (SKUDetail != null && SKUDetail.LaborDetails != null)
                        labordetail = SKUDetail.LaborDetails;

                    if (labordetail.length > 0)
                        for (let i = 0; i < labordetail.length; i++) {
                            LaborRate += labordetail[i].LabourAmount;
                            delete labordetail[i].WstPer;
                            delete labordetail[i].WstWt;
                        }
                }


                if (!Item.HasBom) {

                    Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                    if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && !useCostRate)
                        Rate = RateHelper.GetMetalRate(Item.MetalId, Item.KaratId, false, date) / ExchangeRate;
                    else
                        Rate = Item.UnitRate;
                    if (Item.Purity == 0) {
                        let KaratId = Q.toId(Item.KaratId);
                        let purity: OMS.AttributeMasterRow;
                        OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                            purity = response.Entity
                        }, { async: false });
                        let std = purity.StdPurity;
                        Purity = std;
                    } else
                        Purity = Item.Purity
                }


                // #region ProductBOM
                if (Item.HasBom) {
                    Item.BOMDetails.forEach(function (ItemBOM) {
                        switch (ItemBOM.ItemTypeId) {
                            case 104:
                                {
                                    if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && !useCostRate) {
                                        //BOMRate = RateHelper.GetMetalRate(ItemBOM.ProductTypeId, ItemBOM.KaratId, false, date) / ExchangeRate;
                                        Stock.StockItemService.GetWeightedAVGRate({
                                            ItemTypeId: 104, ProductTypeId: ItemBOM.ProductTypeId
                                        }, response => BOMRate = response.Rate, { async: false }
                                        );

                                    }
                                    else
                                        BOMRate = ItemBOM.BomRate;

                                    let BOMAmount = 0;
                                    let UseKaratRate = q.ToBool(GetConfigValue(1014));
                                    if (UseKaratRate == true)
                                        BOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) : ItemBOM.Weight * BOMRate;
                                    else
                                        BOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * ItemBOM.Purity * BOMRate;
                                    Rate += BOMAmount;

                                    let SalesBOM: Sales.SalesItemsBOMRow = {
                                        ProductId: ItemBOM.ProductId,
                                        ProductCode: ItemBOM.ProductCode,
                                        BOMProductId: ItemBOM.BOMProductId,
                                        BOMAttributeId: ItemBOM.BOMAttributeId,
                                        BomRate: BOMRate,
                                        BomAmount: BOMAmount,
                                        Remarks: ItemBOM.Remarks,
                                        CalcOnId: ItemBOM.CalcOnId,
                                        CalcOn: ItemBOM.CalcOn,
                                        Pieces: ItemBOM.Pieces,
                                        Weight: ItemBOM.Weight,
                                        ItemTypeId: ItemBOM.ItemTypeId,
                                        ItemType: ItemBOM.ItemType,
                                        KaratId: ItemBOM.KaratId,
                                        MetalColorId: ItemBOM.MetalColorId,
                                        Attribute: ItemBOM.Attribute,
                                        CertificateNo: ItemBOM.CertificateNo,
                                        Purity: ItemBOM.Purity,
                                        PureWeight: ItemBOM.PureWeight == null ? ItemBOM.Purity * ItemBOM.Weight : ItemBOM.PureWeight,
                                        RefTransBomId: ItemBOM.TransBomId,
                                        CCBomAmount: BOMAmount * ExchangeRate,
                                        IsCustomerItem: ItemBOM.IsCustomerItem,
                                        CostMethodId: ItemBOM.CostMethodId,
                                        StoneStatusId: 1,
                                        Parts: ItemBOM.Parts == null ? 1 : ItemBOM.Parts,
                                        TextureId: ItemBOM.TextureId == null ? 0 : ItemBOM.TextureId,
                                        SettingId: 0,
                                        PointerWeight: ItemBOM.PointerWeight == null ? 0 : ItemBOM.PointerWeight
                                    }
                                    bomdetails.push(SalesBOM);
                                    break;
                                }
                            case 105:
                                if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && !useCostRate)
                                    BOMRate = RateHelper.GetStoneSalesRate(ItemBOM.BOMAttributeId, RateListId, ItemBOM.BOMProductId, ItemBOM.CostMethodId) / ExchangeRate;
                                else
                                    BOMRate = ItemBOM.BomRate;

                                let BOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) : (ItemBOM.Weight * BOMRate);
                                let CCBOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) * ExchangeRate : (ItemBOM.Weight * BOMRate) * ExchangeRate;

                                Rate += BOMAmount;
                                if (Item.TransId == null && !useCostRate) {

                                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                                        ProductId: ItemBOM.BOMProductId,
                                        AttributeId: ItemBOM.BOMAttributeId,
                                        RateListId: LaborListId,
                                        Markup: LaborMarkup,
                                        Pieces: ItemBOM.Pieces,
                                        Weight: ItemBOM.Weight,
                                        NetWeight: 0,
                                        SettingId: 0,
                                        IsCustomerItem: ItemBOM.IsCustomerItem
                                    }

                                    let ComponentLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt);
                                    if (ItemBOM.SettingId !== null && ItemBOM.SettingId > 0) {
                                        LaborOpt.SettingId = ItemBOM.SettingId;
                                        let SettingLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt);
                                        if (SettingLabor.length > 0)
                                            for (let setting of SettingLabor)
                                                ComponentLabor.push(setting);
                                    }
                                    if (ComponentLabor.length > 0) {
                                        for (let i = 0; i < ComponentLabor.length; i++) {
                                            ComponentLabor[i].LabourRate = ComponentLabor[i].LabourRate / ExchangeRate;
                                            ComponentLabor[i].LabourAmount = ComponentLabor[i].LabourAmount / ExchangeRate;
                                            ComponentLabor[i].CCLabourAmount = ComponentLabor[i].LabourAmount;
                                            LaborRate += ComponentLabor[i].LabourAmount;
                                            labordetail.push(ComponentLabor[i]);
                                        }
                                    }
                                }

                                let SalesBOM: Sales.SalesItemsBOMRow = {
                                    ProductId: ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: BOMAmount,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: ItemBOM.CalcOn,
                                    Pieces: ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemType: ItemBOM.ItemType,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    StoneColorId: ItemBOM.StoneColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    CategoryId: ItemBOM.CategoryId,
                                    SubCategoryId: ItemBOM.SubCategoryId,
                                    ProductTypeId: ItemBOM.ProductTypeId,
                                    QualityId: ItemBOM.QualityId,
                                    SieveId: ItemBOM.SieveId,
                                    ShapeId: ItemBOM.ShapeId,
                                    StoneSizeId: ItemBOM.StoneSizeId,
                                    SettingId: ItemBOM.SettingId == null ? 0 : ItemBOM.SettingId,
                                    GroupSieveId: ItemBOM.GroupSieveId,
                                    StoneCuletId: ItemBOM.StoneCuletId,
                                    StoneCutId: ItemBOM.StoneCutId,
                                    StoneFluorescenceId: ItemBOM.StoneFluorescenceId,
                                    StoneGirdleId: ItemBOM.StoneGirdleId,
                                    StonePolishId: ItemBOM.StonePolishId,
                                    StoneSymmetryId: ItemBOM.StoneSymmetryId,
                                    StoneDepth: ItemBOM.StoneDepth,
                                    Lab: Item.Lab,
                                    StoneTable: ItemBOM.StoneTable,
                                    RefTransBomId: ItemBOM.TransBomId,
                                    CCBomAmount: BOMAmount * ExchangeRate,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    StoneStatusId: 1,
                                    PureWeight: 0,
                                    Purity: 0,
                                    PointerWeight: ItemBOM.PointerWeight == null ? 0 : ItemBOM.PointerWeight,
                                    TextureId: 0
                                }
                                bomdetails.push(SalesBOM)
                                break;
                        }
                    });
                }
                // #endregion
            }

            // #endregion

            // #region Amount Calculation
            if (Item.ItemTypeId == 101) {
                Cost = Rate + LaborRate;
                Amount = Item.HasBom == true ? (Rate + LaborRate) * Item.Pieces : (Rate * Item.Weight) * Purity || 0;
            }
            else if (Item.ItemTypeId == 104) {
                Cost = Rate + LaborRate;
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : (Rate * Item.Weight) * Purity || 0;

            }
            else if (Item.ItemTypeId == 105) {
                Cost = Rate + LaborRate;
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : Rate * Item.Weight || 0;
            }

            //Location = OMS.DepartmentMasterRow.getLookup().itemById[Item.DepartmentId].DeptName;

            // #endregion

            let SalesItem: Sales.SalesItemsRow = {
                ProductId: Item.ProductId,
                AttributeId: Item.AttributeId,
                Attribute: Item.Attribute,
                Line_No: Item.Line_No == null ? Item.LineNo : Item.Line_No,
                PartyId: PartyId,
                SKU: Item.SKU,
                DepartmentId: Item.DepartmentId,
                DeptName: Item.DeptName,
                ProductCode: Item.ProductCode,
                ProductName: Item.ProductName,
                ItemTypeId: Item.ItemTypeId,
                HasBom: Item.HasBom,
                CategoryId: Item.CategoryId,
                ProductTypeId: Item.ProductTypeId,
                SubCategoryId: Item.SubCategoryId,
                BrandId: Item.BrandId,
                SuperTypeId: Item.SuperTypeId,
                CollectionId: Item.CollectionId,
                ProductSizeId: Item.ProductSizeId,
                UnitRate: Rate,
                UnitLabour: LaborRate,
                UnitCost: Cost,
                Pieces: Item.Pieces >= 0 ? Item.Pieces : 0,
                Weight: Item.Weight,
                OtherPieces: Item.OtherPieces,
                OtherWeight: Item.OtherWeight,
                StonePieces: Item.StonePieces,
                StoneWeight: Item.StoneWeight,
                NetWeight: Item.NetWeight,
                NetAmount: Amount,
                GrossAmount: Amount,
                DiamondPieces: Item.DiamondPieces,
                DiamondWeight: Item.DiamondWeight,
                CalcOnId: Item.CalcOnId,
                BOMDetails: bomdetails,
                LaborDetails: labordetail,
                CompanyId: CompanyId,
                HSN: Item.HSN,
                TaxCode: Item.TaxCode,
                MetalId: Item.MetalId,
                KaratId: Item.KaratId,
                MetalColorId: Item.MetalColorId,
                QualityId: Item.QualityId,
                SieveId: Item.SieveId,
                ShapeId: Item.ShapeId,
                StoneColorId: Item.StoneColorId,
                StoneSizeId: Item.StoneSizeId,
                ImageName: Item.ImageName,
                Studded: Studded, // marking item as bulk
                StoneCutId: Item.StoneCutId,
                StonePolishId: Item.StonePolishId,
                StoneSymmetryId: Item.StoneSymmetryId,
                StoneFluorescenceId: Item.StoneFluorescenceId,
                StoneCuletId: Item.StoneCuletId,
                StoneGirdleId: Item.StoneGirdleId,
                StoneTable: Item.StoneTable,
                StoneDepth: Item.StoneDepth,
                Lab: Item.Lab,
                CertificateNo: Item.CertificateNo,
                Purity: Purity,
                CalcUnitId: Item.CalcUnitId,
                LotNo: Item.LotNo,
                PureWeight: Weight * Purity,
                RefVoucherId: Item.VoucherTypeId,
                RefTransId: Item.TransId,
                RefTransItemId: Item.TransItemId,
                CCGrossAmount: Amount * ExchangeRate,
                CCNetAmount: Amount * ExchangeRate,
                StockAllocation: Item.StockAllocation,
                BagNo: Item.BagNo,
                Hallmark: Item.Hallmark,
                Parts: Item.Parts,
                HUID: Item.HUID,
                StampId: Item.StampId,
                CostMethodId: Item.CostMethodId,
                RefNo: Item.RefNo,
                Rate: Item.Rate,
                MF: Item.MF,
                MFAmount: Item.MFAmount,
                ExportPieces: Item.ExportPieces


            };

            ItemDetails.push(SalesItem);
        });

        return ItemDetails;
    }

    export function SetLocationTransferItemGrid(Items: any[], date: Date, PartyId: number, ExchangeRate: number, RateListId: number, LaborListId: number, LaborMarkup: number) {
        let ItemDetails = [];

        let useCostRate = q.ToBool(GetConfigValue(1023));
        Items.forEach(function (Item) {
            // #region variables
            let CompanyId = Q.Authorization.userDefinition.CompanyId;
            let Rate = 0;
            let LaborRate = 0;
            let Pieces = 0;
            let Weight = 0;
            let BOMRate = 0;
            let Amount = 0;
            let Cost = 0;
            let Studded: number;
            let Purity = 0;
            let PurityDetails: OMS.AttributeMasterRow;
            let bomdetails = [];
            let labordetail = [];
            let Location: string;


            // #endregion

            // #region RM Rate
            try {
                switch (Item.ItemTypeId) {
                    case 104:
                        // TODO: Add Currency, Date, Rate Type
                        if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32, useCostRate == false) {
                            Rate = RateHelper.GetMetalRate(Item.ProductTypeId, Item.KaratId, false, date) / ExchangeRate;
                        }
                        else {
                            Rate = Item.UnitRate;
                            Weight = Item.Weight;
                            Pieces = Item.Pieces;
                        }

                        Purity = Item.StdPurity;
                        Studded = 0;

                        if (Purity == 0) {
                            let KaratId = Q.toId(Item.KaratId);
                            let purity: OMS.AttributeMasterRow;
                            OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                purity = response.Entity
                            }, { async: false });
                            let std = purity.StdPurity;
                            Purity = std;
                        }
                        break;
                    case 105:
                        if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32, useCostRate == false) {
                            Rate = RateHelper.GetStoneSalesRate(Item.AttributeId, RateListId, Item.ProductId, Item.CostMethodId) / ExchangeRate;
                        }
                        else {
                            Rate = Item.UnitRate;
                            Weight = Item.Weight;
                            Pieces = Item.Pieces;
                        }
                        Studded = 0;
                        break;
                }
            }
            catch (undefined) {
                Q.notifyWarning("Rate not defined for " + Item.ProductCode);
            }

            // #endregion

            // #region FG
            if (Item.ItemTypeId == 101) {
                if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32, useCostRate == false) {

                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                        ProductId: Item.ProductId,
                        AttributeId: Item.AttributeId,
                        RateListId: LaborListId,
                        Markup: LaborMarkup,
                        Pieces: Item.Pieces,
                        Weight: Item.Weight,
                        NetWeight: Item.NetWeight
                    }

                    let ItemLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt)
                    if (ItemLabor.length > 0)
                        for (let i = 0; i < ItemLabor.length; i++) {
                            ItemLabor[i].LabourRate = ItemLabor[i].LabourRate / ExchangeRate;
                            ItemLabor[i].LabourAmount = ItemLabor[i].LabourAmount / ExchangeRate;
                            ItemLabor[i].CCLabourAmount = ItemLabor[i].LabourAmount;
                            LaborRate += ItemLabor[i].LabourAmount;
                            labordetail.push(ItemLabor[i]);
                        }
                }
                else {
                    if (Item.LabourDetails != null)
                        labordetail = Item.LabourDetails;

                    if (labordetail.length > 0)
                        for (let i = 0; i < labordetail.length; i++) {
                            LaborRate += labordetail[i].LabourAmount;
                        }
                }


                if (!Item.HasBom) {

                    Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                    if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32, useCostRate == false)
                        Rate = RateHelper.GetMetalRate(Item.MetalId, Item.KaratId, false, date) / ExchangeRate;
                    else
                        Rate = Item.UnitRate;
                    if (Item.Purity == 0) {
                        let KaratId = Q.toId(Item.KaratId);
                        let purity: OMS.AttributeMasterRow;
                        OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                            purity = response.Entity
                        }, { async: false });
                        let std = purity.StdPurity;
                        Purity = std;
                    } else
                        Purity = Item.Purity
                }


                // #region ProductBOM
                if (Item.HasBom) {
                    Item.BOMDetails.forEach(function (ItemBOM) {
                        switch (ItemBOM.ItemTypeId) {
                            case 104:
                                {
                                    if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32 && useCostRate) {
                                        //BOMRate = RateHelper.GetMetalRate(ItemBOM.ProductTypeId, ItemBOM.KaratId, false, date) / ExchangeRate;

                                        Stock.StockItemService.GetWeightedAVGRate(
                                            {
                                                ItemTypeId: 104, ProductTypeId: ItemBOM.ProductTypeId
                                            },
                                            response => BOMRate = response.Rate,
                                            {
                                                async: false
                                            }
                                        );
                                    }
                                    else
                                        BOMRate = ItemBOM.BomRate;

                                    let BOMAmount = 0;
                                    let UseKaratRate = q.ToBool(GetConfigValue(1014));

                                    if (UseKaratRate == true)
                                        BOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) : ItemBOM.Weight * BOMRate;
                                    else
                                        BOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * ItemBOM.Purity * BOMRate;
                                    Rate += BOMAmount;

                                    let CCBOMAmount = BOMAmount * ExchangeRate;
                                    let SalesBOM: Sales.SalesItemsBOMRow = {
                                        ProductId: ItemBOM.ProductId,
                                        ProductCode: ItemBOM.ProductCode,
                                        BOMProductId: ItemBOM.BOMProductId,
                                        BOMAttributeId: ItemBOM.BOMAttributeId,
                                        BomRate: BOMRate,
                                        BomAmount: BOMAmount,
                                        Remarks: ItemBOM.Remarks,
                                        CalcOnId: ItemBOM.CalcOnId,
                                        CalcOn: ItemBOM.CalcOn,
                                        Pieces: ItemBOM.Pieces,
                                        Weight: ItemBOM.Weight,
                                        ItemTypeId: ItemBOM.ItemTypeId,
                                        ItemType: ItemBOM.ItemType,
                                        KaratId: ItemBOM.KaratId,
                                        MetalColorId: ItemBOM.MetalColorId,
                                        Attribute: ItemBOM.Attribute,
                                        CertificateNo: ItemBOM.CertificateNo,
                                        Purity: ItemBOM.Purity,
                                        PureWeight: ItemBOM.Weight * ItemBOM.Purity,
                                        RefTransBomId: ItemBOM.TransBomId,
                                        IsCustomerItem: ItemBOM.IsCustomerItem,
                                        CostMethodId: ItemBOM.CostMethodId,
                                        StoneStatusId: 1,
                                        Parts: ItemBOM.Parts == null ? 1 : ItemBOM.Parts,
                                        TextureId: ItemBOM.TextureId == null ? 0 : ItemBOM.TextureId,
                                        SettingId: 0,

                                        CCBomAmount: CCBOMAmount
                                    }
                                    bomdetails.push(SalesBOM);
                                    break;
                                }
                            case 105:
                                if (Item.VoucherTypeId != 16 && Item.VoucherTypeId != 32, useCostRate == false)
                                    BOMRate = RateHelper.GetStoneSalesRate(ItemBOM.BOMAttributeId, RateListId, ItemBOM.BOMProductId, ItemBOM.CostMethodId) / ExchangeRate;
                                else
                                    BOMRate = ItemBOM.BomRate;

                                let BOMAmount = ItemBOM.CalcOnId == 3 ? (ItemBOM.Pieces * BOMRate) : (ItemBOM.Weight * BOMRate);
                                let CCBOMAmount = BOMAmount * ExchangeRate;

                                Rate += BOMAmount;

                                let SalesBOM: Sales.SalesItemsBOMRow = {
                                    ProductId: ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: BOMAmount,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: ItemBOM.CalcOn,
                                    Pieces: ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemType: ItemBOM.ItemType,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    StoneColorId: ItemBOM.StoneColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    CategoryId: ItemBOM.CategoryId,
                                    SubCategoryId: ItemBOM.SubCategoryId,
                                    ProductTypeId: ItemBOM.ProductTypeId,
                                    QualityId: ItemBOM.QualityId,
                                    SieveId: ItemBOM.SieveId,
                                    ShapeId: ItemBOM.ShapeId,
                                    StoneSizeId: ItemBOM.StoneSizeId,
                                    SettingId: ItemBOM.SettingId == null ? 0 : ItemBOM.SettingId,
                                    GroupSieveId: ItemBOM.GroupSieveId,
                                    StoneCuletId: ItemBOM.StoneCuletId,
                                    StoneCutId: ItemBOM.StoneCutId,
                                    StoneFluorescenceId: ItemBOM.StoneFluorescenceId,
                                    StoneGirdleId: ItemBOM.StoneGirdleId,
                                    StonePolishId: ItemBOM.StonePolishId,
                                    StoneSymmetryId: ItemBOM.StoneSymmetryId,
                                    StoneDepth: ItemBOM.StoneDepth,
                                    StoneTable: ItemBOM.StoneTable,
                                    Lab: Item.Lab,
                                    RefTransBomId: ItemBOM.TransBomId,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    StoneStatusId: 1,
                                    PureWeight: 0,
                                    Purity: 0,
                                    CCBomAmount: CCBOMAmount,
                                    TextureId: 0,
                                    Parts: ItemBOM.Parts == null ? 1 : ItemBOM.Parts,
                                }
                                bomdetails.push(SalesBOM)
                                break;
                        }
                    });
                }
                // #endregion
            }

            // #endregion

            // #region Amount Calculation
            if (Item.ItemTypeId == 101) {
                Cost = Rate + LaborRate;
                Amount = Item.HasBom == true ? (Rate + LaborRate) * Item.Pieces : (Rate * Item.Weight) * Purity || 0;
            }
            else if (Item.ItemTypeId == 104) {
                Cost = Rate + LaborRate;
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : (Rate * Item.Weight) * Purity || 0;

            }
            else if (Item.ItemTypeId == 105) {
                Cost = Rate + LaborRate;
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Item.Pieces : Rate * Item.Weight || 0;
            }

            //Location = OMS.DepartmentMasterRow.getLookup().itemById[Item.DepartmentId].DeptName;

            // #endregion

            let SalesItem: Sales.SalesItemsRow = {
                ProductId: Item.ProductId,
                AttributeId: Item.AttributeId,
                Attribute: Item.Attribute,
                Line_No: Item.Line_No == null ? Item.LineNo : Item.Line_No,
                //PartyId: PartyId,
                SKU: Item.SKU,
                DepartmentId: Item.DepartmentId,
                DeptName: Item.DeptName,
                ProductCode: Item.ProductCode,
                ProductName: Item.ProductName,
                ItemTypeId: Item.ItemTypeId,
                HasBom: Item.HasBom,
                CategoryId: Item.CategoryId,
                ProductTypeId: Item.ProductTypeId,
                SubCategoryId: Item.SubCategoryId,
                BrandId: Item.BrandId,
                SuperTypeId: Item.SuperTypeId,
                CollectionId: Item.CollectionId,
                ProductSizeId: Item.ProductSizeId,
                UnitRate: Rate,
                UnitLabour: LaborRate,
                UnitCost: Cost,
                Pieces: Item.Pieces >= 0 ? Item.Pieces : 0,
                Weight: Item.Weight,
                OtherPieces: Item.OtherPieces,
                OtherWeight: Item.OtherWeight,
                StonePieces: Item.StonePieces,
                StoneWeight: Item.StoneWeight,
                NetWeight: Item.NetWeight,
                NetAmount: Amount,
                GrossAmount: Amount,
                DiamondPieces: Item.DiamondPieces,
                DiamondWeight: Item.DiamondWeight,
                CalcOnId: Item.CalcOnId,
                BOMDetails: bomdetails,
                // LaborDetails: labordetail,
                CompanyId: CompanyId,
                HSN: Item.HSN,
                TaxCode: Item.TaxCode,
                MetalId: Item.MetalId,
                KaratId: Item.KaratId,
                MetalColorId: Item.MetalColorId,
                QualityId: Item.QualityId,
                SieveId: Item.SieveId,
                ShapeId: Item.ShapeId,
                StoneColorId: Item.StoneColorId,
                StoneSizeId: Item.StoneSizeId,
                ImageName: Item.ImageName,
                Studded: Studded, // marking item as bulk
                StoneCutId: Item.StoneCutId,
                StonePolishId: Item.StonePolishId,
                StoneSymmetryId: Item.StoneSymmetryId,
                StoneFluorescenceId: Item.StoneFluorescenceId,
                StoneCuletId: Item.StoneCuletId,
                StoneGirdleId: Item.StoneGirdleId,
                StoneTable: Item.StoneTable,
                StoneDepth: Item.StoneDepth,
                Lab: Item.Lab,
                CertificateNo: Item.CertificateNo,
                Purity: Purity,
                CalcUnitId: Item.CalcUnitId,
                LotNo: Item.LotNo,
                PureWeight: Weight * Purity,
                RefVoucherId: Item.VoucherTypeId,
                RefTransId: Item.TransId,
                RefTransItemId: Item.TransItemId,
                StockAllocation: Item.StockAllocation,
                BagNo: Item.BagNo,
                Hallmark: Item.Hallmark,
                Parts: Item.Parts,
                HUID: Item.HUID,
                StampId: Item.StampId,
                CostMethodId: Item.CostMethodId,
                MF: Item.MF,
                MFAmount: Item.MFAmount,
                ExportPieces: Item.ExportPieces,



            };

            ItemDetails.push(SalesItem);
        });

        return ItemDetails;
    }

    export function SetProduct(Item: any, date: Date, RateListId: number, Markup: number, LaborListId: number, LaborMarkup: number, CalculateRate: boolean) {
        let labordetail = [];
        let bomdetails = [];
        let Rate = 0; let LaborRate = 0; let Pieces = 0; let Weight = 0; let BOMRate = 0; let Purity = 0; let Amount = 0;
        if (CalculateRate) {

            let GetSKUPrice = q.ToBool(GetConfigValue(1024))
            let SKUDetail: Inventory.SKUItemsRow;


            // #region RM Rate
            try {
                switch (Item.ItemTypeId) {
                    case 104:
                        // TODO: Add Currency, Date, Rate Type
                        if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47) {
                            Rate = RateHelper.GetMetalRate(Item.ProductTypeId, Item.KaratId, false, date);
                        }
                        else {
                            Rate = Item.UnitRate;
                            Weight = Item.Weight;
                            Pieces = Item.Pieces;
                        }

                        Purity = Item.Purity;

                        if (Purity == 0) {
                            let KaratId = Q.toId(Item.KaratId);
                            let purity: OMS.AttributeMasterRow;
                            OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                                purity = response.Entity
                            }, { async: false });
                            let std = purity.StdPurity;
                            Purity = std;
                        }
                        break;
                    case 105:
                        if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47) {
                            Rate = RateHelper.GetStoneSalesRate(Item.AttributeId, RateListId, Item.ProductId, Item.CostMethodId);
                        }
                        else {
                            Rate = Item.UnitRate;
                        }
                        break;
                }
            }
            catch (undefined) {
                Q.notifyWarning("Rate not defined for " + Item.ProductCode);
            }

            // #endregion

            // #region FG
            if (Item.ItemTypeId == 101) {

                if (GetSKUPrice && !Q.isEmptyOrNull(Item.SKU)) {

                    Inventory.SKUItemsService.GetSKUDetails({ SKU: Item.SKU, Line_No: Item.Line_No }, response => SKUDetail = response.Entities[0], { async: false });
                }

                Pieces = 1;
                Weight = Item.Weight == 0 ? 1 : Item.Weight;
                if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47 && SKUDetail == null) {
                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                        ProductId: Item.ProductId,
                        AttributeId: Item.AttributeId,
                        RateListId: LaborListId,
                        Markup: LaborMarkup,
                        Pieces: Item.Pieces,
                        Weight: Item.Weight,
                        NetWeight: Item.NetWeight
                    }

                    let ItemLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt);
                    if (ItemLabor.length > 0)
                        for (let i = 0; i < ItemLabor.length; i++) {
                            LaborRate += Markup > 0 ? (ItemLabor[i].LabourAmount * (Markup / 100)) + ItemLabor[i].LabourAmount : ItemLabor[i].LabourAmount;
                            labordetail.push(ItemLabor[i]);
                        }
                }
                else if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47 && SKUDetail != null) {
                    labordetail = SKUDetail.LaborDetails;
                    for (let i = 0; i < labordetail.length; i++) {

                        LaborRate += Markup > 0 ? (labordetail[i].LabourAmount * (Markup / 100)) + labordetail[i].LabourAmount : labordetail[i].LabourAmount;
                    }
                }
                else {
                    labordetail = Item.LabourDetails;
                    for (let i = 0; i < labordetail.length; i++) {

                        LaborRate += Markup > 0 ? (labordetail[i].LabourAmount * (Markup / 100)) + labordetail[i].LabourAmount : labordetail[i].LabourAmount;
                    }
                }


                if (!Item.HasBom) {

                    Q.reloadLookup(OMS.MetalRateMasterRow.lookupKey)
                    if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47)
                        Rate = RateHelper.GetMetalRate(Item.MetalId, Item.KaratId, true, date);
                    else
                        Rate = Item.UnitRate;
                    if (Item.Purity == 0) {
                        let KaratId = Q.toId(Item.KaratId);
                        let purity: OMS.AttributeMasterRow;
                        OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                            purity = response.Entity
                        }, { async: false });
                        let std = purity.StdPurity;
                        Purity = std;
                    } else
                        Purity = Item.Purity
                }


                // #region ProductBOM
                if (Item.HasBom) {
                    Item.BOMDetails.forEach(function (ItemBOM: OMS.ProductBOMRow) {
                        switch (ItemBOM.ItemTypeId) {
                            case 104: {
                                if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47)
                                    BOMRate = RateHelper.GetMetalRate(ItemBOM.ProductTypeId, ItemBOM.KaratId, true, date);
                                else
                                    BOMRate = ItemBOM.BomRate;

                                let BOMAmount = 0;
                                let UseKaratRate = q.ToBool(GetConfigValue(1014));

                                if (UseKaratRate == true)
                                    BOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * BOMRate;
                                else
                                    BOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * ItemBOM.Purity * BOMRate;
                                Rate += BOMAmount;

                                let SalesBOM: OMS.ProductBOMRow = {
                                    ProductId: ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: BOMAmount,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: ItemBOM.CalcOn,
                                    Pieces: ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    ItemType: ItemBOM.ItemType,
                                    KaratId: ItemBOM.KaratId,
                                    MetalColorId: ItemBOM.MetalColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    Purity: ItemBOM.Purity,
                                    PureWeight: ItemBOM.PureWeight,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    TextureId: ItemBOM.TextureId == null ? 0 : ItemBOM.TextureId,
                                    Parts: ItemBOM.Parts == null ? 1 : ItemBOM.Parts,
                                    PointerWeight: ItemBOM.PointerWeight == null ? 0 : ItemBOM.PointerWeight,

                                }
                                bomdetails.push(SalesBOM);
                                break;
                            }
                            case 105:
                                if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47) {
                                    if (SKUDetail != null) {
                                        let SKUBom = Q.tryFirst(SKUDetail.BOMDetails, x => x.BOMAttributeId == ItemBOM.BOMAttributeId);
                                        BOMRate = Markup > 0 ? (SKUBom.BomRate * (Markup / 100)) + SKUBom.BomRate : SKUBom.BomRate;
                                    }
                                    else {
                                        let bvalue = RateHelper.GetStoneSalesRate(ItemBOM.BOMAttributeId, RateListId, ItemBOM.BOMProductId, ItemBOM.CostMethodId, ItemBOM.Weight)
                                        BOMRate = Markup > 0 ? (bvalue * (Markup / 100)) + bvalue : bvalue;
                                    }
                                }
                                else
                                    BOMRate = ItemBOM.BomRate;
                                let BOMAmount = ItemBOM.CalcOnId == 3 ? ItemBOM.Pieces * BOMRate : ItemBOM.Weight * BOMRate;
                                Rate += BOMAmount;
                                if (Item.VoucherTypeId != 46 && Item.VoucherTypeId != 47 && !GetSKUPrice) {

                                    let LaborOpt: TabAurous.RateHelper.LaborCalOptions = {
                                        ProductId: ItemBOM.BOMProductId,
                                        AttributeId: ItemBOM.BOMAttributeId,
                                        RateListId: LaborListId,
                                        Markup: LaborMarkup,
                                        Pieces: ItemBOM.Pieces,
                                        Weight: ItemBOM.Weight,
                                        NetWeight: 0,
                                        SettingId: 0,
                                        IsCustomerItem: ItemBOM.IsCustomerItem
                                    }

                                    let ComponentLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt);
                                    if (ItemBOM.SettingId !== null && ItemBOM.SettingId > 0) {
                                        LaborOpt.SettingId = ItemBOM.SettingId;
                                        let SettingLabor: Sales.SalesLaborRow[] = RateHelper.GetSalesLabour(LaborOpt);
                                        if (SettingLabor.length > 0)
                                            for (let setting of SettingLabor)
                                                ComponentLabor.push(setting);
                                    }
                                    if (ComponentLabor.length > 0) {
                                        for (let i = 0; i < ComponentLabor.length; i++) {
                                            LaborRate += Markup > 0 ? (ComponentLabor[i].LabourAmount * (Markup / 100)) + ComponentLabor[i].LabourAmount : ComponentLabor[i].LabourAmount;
                                            labordetail.push(ComponentLabor[i]);
                                        }
                                    }
                                }

                                let SalesBOM: OMS.ProductBOMRow = {
                                    ProductId: ItemBOM.ProductId,
                                    ProductCode: ItemBOM.ProductCode,
                                    BOMProductId: ItemBOM.BOMProductId,
                                    BOMAttributeId: ItemBOM.BOMAttributeId,
                                    BomRate: BOMRate,
                                    BomAmount: BOMAmount,
                                    Remarks: ItemBOM.Remarks,
                                    CalcOnId: ItemBOM.CalcOnId,
                                    CalcOn: ItemBOM.CalcOn,
                                    Pieces: ItemBOM.Pieces,
                                    Weight: ItemBOM.Weight,
                                    ItemType: ItemBOM.ItemType,
                                    ItemTypeId: ItemBOM.ItemTypeId,
                                    StoneColorId: ItemBOM.StoneColorId,
                                    Attribute: ItemBOM.Attribute,
                                    CertificateNo: ItemBOM.CertificateNo,
                                    CategoryId: ItemBOM.CategoryId,
                                    SubCategoryId: ItemBOM.SubCategoryId,
                                    ProductTypeId: ItemBOM.ProductTypeId,
                                    QualityId: ItemBOM.QualityId,
                                    SieveId: ItemBOM.SieveId,
                                    ShapeId: ItemBOM.ShapeId,
                                    StoneSizeId: ItemBOM.StoneSizeId,
                                    SettingId: ItemBOM.SettingId == null ? 0 : ItemBOM.SettingId,
                                    GroupSieveId: ItemBOM.GroupSieveId,
                                    StoneCuletId: ItemBOM.StoneCuletId,
                                    StoneCutId: ItemBOM.StoneCutId,
                                    StoneFluorescenceId: ItemBOM.StoneFluorescenceId,
                                    StoneGirdleId: ItemBOM.StoneGirdleId,
                                    StonePolishId: ItemBOM.StonePolishId,
                                    StoneSymmetryId: ItemBOM.StoneSymmetryId,
                                    StoneDepth: ItemBOM.StoneDepth,
                                    StoneTable: ItemBOM.StoneTable,
                                    IsCustomerItem: ItemBOM.IsCustomerItem,
                                    CostMethodId: ItemBOM.CostMethodId,
                                    Parts: ItemBOM.Parts == null ? 1 : ItemBOM.Parts,
                                    TextureId: ItemBOM.TextureId == null ? 0 : ItemBOM.TextureId
                                }
                                bomdetails.push(SalesBOM)
                                break;
                        }
                    });
                }
                // #endregion
            }

            // #endregion

            // #region Amount Calculation
            if (Item.ItemTypeId == 101) {
                Amount = Item.HasBom == true ? (Rate + LaborRate) * Pieces : (Rate * Weight) * Purity || 0;
            }
            else if (Item.ItemTypeId == 104) {

                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Pieces : (Rate * Weight) * Purity || 0;

            }
            else if (Item.ItemTypeId == 105) {
                Amount = Item.CalcOnId == 3 ? (Rate + LaborRate) * Pieces : Rate * Weight || 0;
            }
        }
        if (!q.isNumber(Item.Pieces) || Item.Pieces == 0)
            Item.Pieces = 1;
        let SalesItem: OMS.ProductMasterRow = {
            ProductId: Item.ProductId,
            AttributeId: Item.AttributeId,
            Attribute: Item.Attribute,
            SKU: Item.SKU,
            ProductCode: Item.ProductCode,
            ProductName: Item.ProductName,
            ItemTypeId: Item.ItemTypeId,
            HasBom: Item.HasBom,
            CategoryId: Item.CategoryId,
            ProductTypeId: Item.ProductTypeId,
            SubCategoryId: Item.SubCategoryId,
            BrandId: Item.BrandId,
            SuperTypeId: Item.SuperTypeId,
            CollectionId: Item.CollectionId,
            ProductSizeId: Item.ProductSizeId,
            Rate: CalculateRate ? Rate : Item.Rate,
            UnitLabour: CalculateRate ? LaborRate : Item.UnitLabour,
            Pieces: Item.Pieces,
            Weight: Item.Weight,
            OtherPieces: Item.OtherPieces,
            OtherWeight: Item.OtherWeight,
            StonePieces: Item.StonePieces,
            StoneWeight: Item.StoneWeight,
            NetWeight: Item.NetWeight,
            //NetAmount: Amount,
            //GrossAmount: Amount,
            DiamondPieces: Item.DiamondPieces,
            DiamondWeight: Item.DiamondWeight,
            CalcOnId: Item.CalcOnId,
            BOMDetails: CalculateRate ? bomdetails : Item.BOMDetails,
            LaborDetails: CalculateRate ? labordetail : Item.LaborDetails,
            //CompanyId: CompanyId,
            HSN: Item.HSN,
            TaxCode: Item.TaxCode,
            MetalId: Item.MetalId,
            KaratId: Item.KaratId,
            MetalColorId: Item.MetalColorId,
            //QualityId: Item.QualityId,
            //SieveId: Item.SieveId,
            //ShapeId: Item.ShapeId,
            //StoneColorId: Item.StoneColorId,
            //StoneSizeId: Item.StoneSizeId,
            //ImageName: Item.ImageName,
            //Studded: Item.Studded, // marking item as bulk
            //StoneCutId: Item.StoneCutId,
            //StonePolishId: Item.StonePolishId,
            //StoneSymmetryId: Item.StoneSymmetryId,
            //StoneFluorescenceId: Item.StoneFluorescenceId,
            //StoneCuletId: Item.StoneCuletId,
            //StoneGirdleId: Item.StoneGirdleId,
            //StoneTable: Item.StoneTable,
            //StoneDepth: Item.StoneDepth,
            //Lab: Item.Lab,
            //CertificateNo: Item.CertificateNo,
            Purity: Item.Purity == null ? Purity : Item.Purity,
            //LotNo: Item.LotNo,
            CalcUnitId: Item.CalcUnitId,
            //PureWeight: Weight * Purity,
            Parts: Item.Parts,
            CostMethodId: Item.CostMethodId

        };



        return SalesItem;
    }

}